import React, { useEffect, useLayoutEffect, useState } from 'react'
import doctor_img from '../../../assests/images/PatientApoointment/doctorImg.png'
import backgroundlogo from '../../../assests/images/PatientApoointment/backgroundLogo.png'
import patientRecordFound from '../../../assests/images/patientRecordFound.png'
import patientRecordNotFound from '../../../assests/images/patientRecordNotFound.png'
import { FormLabel, Grid, Typography } from '@material-ui/core'
import BookingWith from './StepperComponents/FindYourCare/BookingWith'
import LookingFor from './StepperComponents/FindYourCare/LookingFor'
import LocatedTime from './StepperComponents/FindYourCare/LocatedTime'
import SelectATime from './StepperComponents/SelectATime'
import SelectAProvider from './StepperComponents/SelectAProvider/SelectAProvider'
import SelectAProviderInt from './StepperComponents/SelectAProvider/SelectAProviderInt'
import ReasonForVisit from './StepperComponents/ReasonForVisit'

import ReviewAppointment from './StepperComponents/ReviewAppointment'

import Booking from './Booking'
import BookingButtons from './BookingButtons'

import { INIT_VALUES as NEW_PATIENT_FORM_INIT_VALUES } from './StepperComponents/NewPatientForm/constants'
import { validation as newPatientFormValidation } from './StepperComponents/NewPatientForm/validation'
import { INIT_VALUES as INTAKE_FORM_INIT_VALUES, INIT_VALUES_NEW } from './StepperComponents/IntakeForm/constants'
import { validation as intakeFormValidation, validationnew as intakeFormValidationnew } from './StepperComponents/IntakeForm/validation'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useHistory } from 'react-router-dom'
import IntakeForm from './StepperComponents/IntakeForm/IntakeForm'
import Routes from '../../../constants/routes'
import { useDispatch, useSelector } from 'react-redux'
import { stateList, relationshipOptions } from '../../../containers/AppointmentBooking/constant'
import { TIMEZONES } from '../../../containers/CalendarScheduler/constant'
import { TIMEZONE_OPTONS } from '../../../constants/timezones'
import { useNotification } from '../MaterialUi/Notification'
import { patientTimeZone } from '../../../containers/AppointmentList/utils'
import { addIntakeForm, addIntakeFormNew, cdphPatientFound, cdphPatientUpdate, createInsurance, updateInsurance, getCarrierListApi, getTimeZoneFromZip, newBookAppointment, tm2uPatientCreate, providerListForBook } from '../../../services/Appointments/appointments'
import AppointmentLoadingPage from './StepperComponents/AppointmentLoadingPage'
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import { config } from '../../../constants'
import moment from 'moment'
import { changeHeaderTab } from '../../../store/actions/header'
import { reversedHeaderConstants } from '../../Header/constants'
import { Button, Dialog, Box } from '@mui/material'
import {useMediaQuery, makeStyles} from '@material-ui/core'
import AppointmentDetails from '../../Dashboard/AppointmentDetails'

import { INITIAL_VALUES_PATIENT } from './StepperComponents/FindYourCare/InitialValue'
import CloseIcon from '@mui/icons-material/Close';
import profileImage from '../../../assests/images/PatientApoointment/profileImage.svg'
import TextBox from '../../../shared/elements/FormItem/TextBox'
import DatePicker from '../../../shared/elements/DatePicker/DatePicker'
import { LoadingButton } from '@mui/lab'
import NewPatientCreateForm from './StepperComponents/FindYourCare/NewPatientForm'
import MomentUtils from '@date-io/moment'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { calculateAge, checkTimeForToday, getNextTwoBusinessDays, isWeekend } from '../../utils'
import { setAMDpatientCreate, setPatientCreateObject, setPatientTimeZone,setUpdateInsuranceDetails } from '../../../store/actions/patient'
import CreateInsuranceForm from './StepperComponents/FindYourCare/CreateInsuranceForm'
import CompletedPage from './StepperComponents/CompletedPage'
import SelectLanguage from './StepperComponents/FindYourCare/SelectLanguage'
import { handleClickOnContinue, setPrimaryProviderDetails } from '../../../store/actions/appointments'
import axios from 'axios'
import { jsPDF } from "jspdf";
import BookingButtonWeb from './BookingButtonWeb'
import { useJourneyTracking } from '../../../hooks/userJourneyTracking'
import { InsuranceModal } from './StepperComponents/InsuranceModal'
import IntakeNewModal from './StepperComponents/IntakeForm/IntakeNewModal'
import IntakeTherapyModal from './StepperComponents/IntakeForm/IntakeTherapyModal'
import CheckboxOption from '../../ClinicalNotes/reusable/CheckboxOptions'
import StateConfirmationModal from './StateConfirmationModal'
import AppointmentPostBookingModal from './AppointmentPostBookingModal'

export const getLangCode = (langPath) => {
    // if (!langPath) return 'en' // fallback default

    // Case 1: #googtrans(en|ko)
    const googTransMatch = langPath.match(/#googtrans\([\w-]+\|([\w-]+)\)/);
    if (googTransMatch) {
        return googTransMatch[1]
    }
    // Case 2: /en/ko
    const pathParts = langPath.split('/')
    if (pathParts.length > 2) {
        return pathParts[2]
    }
    return 'en' // fallback
}


const removeEmptyObjects = (formData) => {
    return formData.filter((obj) => {
        // Check if any key is not empty in the current object
        const hasNonEmptyKey = Object.values(obj).some((value) => value !== '')
        // If any key is not empty, keep the object in the array
        return hasNonEmptyKey
    })
}

const USPhoneRegex = new RegExp(
    /(\d{3})(\d{3})(\d{4})/,
)
const zipCodeRegex = /^\d{5}$/

const useStyles = makeStyles(() => ({
    duplicatePatient:{
        background:'#5571C6', 
        width:"100%", 
        height:"25px"
    },
    duplicatePatientHeaderContent:{
        display: "flex",
        alignItems:'center', 
        alignContent: 'center', 
        justifyContent:"end", 
        paddingRight:"10px",
        cursor:'pointer'
    },
    duplicatePatientHeader1:{
        fontSize: '20px', 
        color: '#000',
        margin: '30px 0px 10px 0px',
        fontWeight: "450",
        fontFamily: 'Inter',
    },
    duplicatePatientHeader2:{
        fontSize: '17px', 
        color: '#000',
        margin: '10px 0px 14px 0px',
        fontWeight: "400",
        fontFamily: 'Inter',
    },
    duplicatePatientHeader3:{
        fontSize: '20px', 
        color: '#000',
        margin: '10px 0px 10px 0px',
        fontWeight: "450",
        fontFamily: 'Inter',
    },
    existPatient:{
        background:'#5571C6', 
        width:"100%", 
        paddingTop:"2px"
    },
    existPatientCheck:{
        display: "flex",
        alignItems:'center', 
        alignContent: 'center', 
        justifyContent:"space-between", 
        paddingRight:"10px",
        cursor:'pointer'
    },
    existPatientHeader1:{
        fontSize: '24px', 
        fontFamily: 'Inter',
        color: '#fff',
        padding :"8px 10px",
        fontWeight: "450",
        
    },
    container: {
        width: '100%',
    },
    form:{
        background: "white",
        padding: "20px 7px 20px 25px",
        border: "1px solid #CFCFCF",
        borderRadius: "10px",
    },
    checkboxLabel: {
        '& .MuiFormControlLabel-root': {
            marginRight: '0 !important',
            '& .MuiIconButton-root': {
                paddingBottom: '0 !important',
                paddingTop: '0 !important',
            },
        },
    },
    mainContainer:{
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column'
    },
    footerContainer:{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#F6F6F6',
        borderTop: '1px solid #DBDBDB',
        height: '78px'
    },
    footerText:{
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '18px',
        color: '#000000',
        paddingLeft: '29px'
    },
    therapyCheckBox: {
        display: 'grid',
        gridTemplateColumns: '1fr 106px',
        ['@media (max-width:768px)']: {
            gridTemplateColumns: '1fr',
            gap: '10px',
        },
    },
    normalText: {
        fontFamily: 'Inter',
        fontSize: '18px',
        fontWeight: 400,
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    backGroundImage:{
        backgroundImage: `url(${backgroundlogo})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left 0px top 172px',
        backgroundSize: "64%"
    },
}))


const getStepName = (stepNumber) => {
  const stepMap = {
    1.5: 'Insurance Form',
    2: 'Find Your Care - without specialties',
    2.01: 'Find Your Care - with specialties',
    2.1: 'Psychiatry/Therapy Intake Modal',
    3: 'Provider Selection',
    3.1: 'Displays Upcoming Appointments',
    3.2: 'Reason for Visit',
    3.3: 'Intake Form (Psychiatry-Adult)',
    3.4: 'Intake Form (Psychiatry-Child)',
    3.5: 'Verify Demography',
    3.6: 'Verify Insurance', 
    3.7: 'Therapy Intake Modal',
  }
  return stepMap[stepNumber] || null
}


function StepperComponents() {    
    const classes = useStyles()
    const history = useHistory()
    const dispatch = useDispatch()
    const userData = useSelector((state) => state?.login?.userData)
    const timeZoneOfPatient = useSelector((state) => state?.patient?.patientTimeZone)
    const notification = useNotification()
    const [isLoading, setIsLoading] = useState(false)
    const [steps, setSteps] = React.useState(0)
    const [fromCreate, setFromCreate] =useState(false)
    const stepperRef = React.useRef(null)
    // const [isFirstTime, setIsFirstTime] = React.useState(true)

    const [appointmentDetails, setAppointmentDetails] = React.useState({})
    const [reviewAppointmentLoader, setReviewAppointmentLoader] = React.useState(true)

    const [intakeFormTouchedFields, setIntakeFormTouchedFields] = React.useState({})
    

    const [findYourCareValues, setFindYourCareValues] = React.useState({
        bookingWith: '',
        locatedTime: '',
        lookingFor: '',
    })
    const[oldLookingFor, setOldLookingFor] = React.useState('')
    const [reasonForVisit, setReasonForVisit] = React.useState('')
    const [requireTranslator, setRequireTranslator] = React.useState(userData?.require_translator)
    const [medications, setMedications] = React.useState([
        {
            name: '',
            strength: '',
            directions: '',
        },
        {
            name: '',
            strength: '',
            directions: '',
        },
        {
            name: '',
            strength: '',
            directions: '',
        },
    ])
    const nowPST = moment().tz(timeZoneOfPatient ||'US/Pacific')
    const [selectATimeValues, setSelectSelectATimeValues] = React.useState({
        morning: true,
        afternoon: true,
        evening: true,
        timezone: '',
        date: getNextTwoBusinessDays(moment(), 3),
    })
    const [checkDisableTime, setCheckDisableTime] = React.useState({
        morning: false,
        afternoon: false,
        evening: false,
        weekend: false,
    })
    const [patientexistForm, setPatientexistForm] = React.useState({
        first_name:'',
        last_name:'',
        middle_name: '',
        zip_code: '',
        dob: ''
    })
    const [selctedProviderDetails, setSelectedProviderDetails] = React.useState({})
    const [selectedTime, setSelectedTime] = React.useState({})
    const [returnedErrorMessage, setReturnedErrorMessage] = useState(false)
    const [providerVisitType, setProviderVisitType] = React.useState({})
    const [sign, setSign] = React.useState('')
    const [isCheckboxEnabled, setIsCheckboxEnabled] = React.useState(false)

    const [intakeFormWarning, setIntakeFormWarning] = useState(false) 
    const [isWaningDismissed, setIsWaningDismissed] = useState(false)
    const [isMobileView, setIsMobileView]= useState(false)

    const [duplicatePatientAlert, setDuplicatePatientAlert] = useState(false) 
    const [patientCheckExist, setPatientCheckExist] = useState(false) 
    const [afterPatientCheckExist, setAfterPatientCheckExist] = useState(false)
    const [patientExistIntheRecord, setPatientExistIntheRecord] = useState(false)  
    const [patientFoundLoading, setPatientFoundLoading]= useState(false)
    const [patientFoundModalLoading, setPatientFoundModalLoading]= useState(false)
    const [validDate, setValidDate] = useState(true)
    const[selfpay, setSelfpay] = useState(false)
    const[selfpayInInsurance, setSelfpayInInsurance] = useState(false)
    const[patientHaveInsurance, setPatientHaveInsurance] = useState(false)
    const[postBookingStep, setPostBookingStep] = useState(3)
    const amdPatientDetails =  useSelector((state) => state?.patient?.amdPatientDetails)
    const demographicDetails =  useSelector((state) => state?.patient?.demographicsDetails)
    const PatientCreateObject = useSelector((state) => state?.patient?.patientCreateObject)
    const offeredDate = useSelector((state) => state?.appointments?.offeredDate)
    const [maxDate, setMaxDate] = React.useState('')
    const [selectedLanguage, setSelectedLanguage] = React.useState('')
    const [patientInsuranceFront, setPatientInsuranceFront] = React.useState('')
    const [patientInsuranceBack, setPatientInsuranceBack] = React.useState('')
    const [uploadProcessFront, setUploadProcessFront] = React.useState('')
    const [uploadProcessBack, setUploadProcessBack] = React.useState('')
    const [providerDetailsFromPatient, setProviderDetailsFromPatient] = React.useState('')
    const [reasonForVisitText, setReasonForVisitText] = React.useState('')
    const [carrierList, setCarrierList] = useState([])
    const [errorMessageForRadio, setErrorMessageforRadio] = useState(false)
    const [loaderOpen, setLoaderOpen] = React.useState(false)
    const [therapyConsentStep, setTherapyConsentStep] = React.useState(1)
    const [checkboxTherapyConsent, setCheckboxTherapyConsent] = React.useState(false)
    const [openIntakeModal, setOpenIntakeModal] = React.useState(false)
    const [openIntakeTherapyModal, setOpenIntakeTherapyModal] = React.useState(false)
    const [billingHoldAlert, setBillingHoldAlert] = useState(false)
    const [providerCount, setProviderCount] = useState(null)
    const [currentModalStep, setCurrentModalStep] = React.useState(null)
    const [providerDetailsModalOpen, setProviderDetailsModalOpen] = React.useState(false)
    const [reasonForVisitModalOpen, setReasonForVisitModalOpen] = React.useState(false)
    const [demographicsModalOpen, setDemographicsModalOpen] = React.useState(false)
    const [insuranceModalOpen, setInsuranceModalOpen] = React.useState(false)
    const updatedInsuranceFromRedux = useSelector((state) => state?.patient?.insuranceDetails)
    const[patientHaveInsuranceExist, setPatientHaveInsuranceExist] = useState(false)
    const [currentInsurance, setCurrentInsurance] = useState(null);
    const [originalInsurance, setOriginalInsurance] = useState(null);
    const[responsible_partyrecieved,setResponsible_party]=useState('')
   
    // Track "Your Care Team" flow - for specialty and provider count tracking
    const [careTeamFlow, setCareTeamFlow] = React.useState(false)
    const [careTeamSpecialty, setCareTeamSpecialty] = React.useState('')
    const [careTeamProviderCount, setCareTeamProviderCount] = React.useState(null)
    const [providerCredentialModalOpen, setProviderCredentialModalOpen] = useState(false)
    const [checkingProviders, setCheckingProviders] = useState(false)
    const [previousInsuranceState, setPreviousInsuranceState] = useState(null)
    const [pendingInsuranceUpdate, setPendingInsuranceUpdate] = useState(null);
   const [selectedProviderIds, setSelectedProviderIds] = useState([]);

    // State location confirmation modal
    const [showStateConfirmModal, setShowStateConfirmModal] = useState(false)
    const [confirmedPatientState, setConfirmedPatientState] = useState(PatientCreateObject?.state || '')
    const [lastSuccessfulState, setLastSuccessfulState] = useState(PatientCreateObject?.state || '')

    const [openPostBookingModal, setOpenPostBookingModal] = useState(false)
    const [reopenProviderDetails, setReopenProviderDetails] = useState(false)

    // Calculate the actual current step including modal sub-steps
    const getCurrentStepWithModal = () => {
        if (currentModalStep !== null) {
            return currentModalStep
        }
        if (steps === 2 && findYourCareValues?.lookingFor) {
            return 2.01
        }
        return steps
    }

    useEffect(() => {
    // Only track if we're on provider selection step and count is 0
    if ((steps === 3 || steps === 3.5) && providerCount === 0) {
        trackNoProviders()
    }
    }, [providerCount, steps])

   // Sync Redux updateInsuranceDetails with currentInsurance state
    useEffect(() => {
        const insuranceId = updatedInsuranceFromRedux.insurance_Id;
        if (validateProviderInsuranceCredential(insuranceId))
            {
                if (updatedInsuranceFromRedux && Object.keys(updatedInsuranceFromRedux).length > 0) {
                setCurrentInsurance({
                    carrier: updatedInsuranceFromRedux.carrier,
                    insurance_Id: updatedInsuranceFromRedux.insurance_Id,
                    insurance_name: updatedInsuranceFromRedux.insurance_name,
                    subscriber_id: updatedInsuranceFromRedux.subscriber_id || updatedInsuranceFromRedux.subscriberNum,
                    subscriberNum:updatedInsuranceFromRedux.subscriber_id || updatedInsuranceFromRedux.subscriberNum,
                    group_name: updatedInsuranceFromRedux.group_name,
                    group_number: updatedInsuranceFromRedux.group_number,
                    relationShip: updatedInsuranceFromRedux.relationship,
                    patientInsuranceFront: updatedInsuranceFromRedux.patientInsuranceFront,
                    patientInsuranceBack: updatedInsuranceFromRedux.patientInsuranceBack,
                })
            }
    }
    }, [updatedInsuranceFromRedux])
    // Track when intake modal (psychiatry) opens/closes
    useEffect(() => {
        if (openIntakeModal) {
            // Determine if it's Adult or Child psychiatry
            if (findYourCareValues?.lookingFor?.toLowerCase().trim().startsWith('psychiatry')) {
                const age = calculateAge(PatientCreateObject?.dob || amdPatientDetails?.dob)
                setCurrentModalStep(age >= 18 ? 3.3 : 3.4) // Psychiatry-Adult : Psychiatry-Child
            } else {
                setCurrentModalStep(2.1) // Generic Intake Modal
            }
        } else {
            setCurrentModalStep(null)
        }
    }, [openIntakeModal, findYourCareValues.lookingFor])

    // Track when therapy intake modal opens/closes
    useEffect(() => {
        if (openIntakeTherapyModal) {
            setCurrentModalStep(3.7) // Therapy Intake Modal
        } else if (!openIntakeModal) {
            setCurrentModalStep(null)
        }
    }, [openIntakeTherapyModal, openIntakeModal])

    // Track intake form warning
    useEffect(() => {
        if (intakeFormWarning) {
            setCurrentModalStep(1.1) // Intake Form Warning Modal
        } else if (currentModalStep === 1.1) {
            setCurrentModalStep(null)
        }
    }, [intakeFormWarning])

    // Track when Provider Details Modal opens/closes
    useEffect(() => {
        if (providerDetailsModalOpen) {
            setCurrentModalStep(3.1) // Provider Details Modal
        } else if (currentModalStep === 3.1) {
            setCurrentModalStep(null)
        }
    }, [providerDetailsModalOpen])

    // Track when Reason for Visit Modal opens/closes
    useEffect(() => {
        if (reasonForVisitModalOpen) {
            setCurrentModalStep(3.2) // Reason for Visit Modal
        } else if (currentModalStep === 3.2) {
            setCurrentModalStep(null)
        }
    }, [reasonForVisitModalOpen])

    // Track when Demographics Modal opens/closes
    useEffect(() => {
        if (demographicsModalOpen) {
            setCurrentModalStep(3.5) // Verify Demographics Modal
        } else if (currentModalStep === 3.5) {
            setCurrentModalStep(null)
        }
    }, [demographicsModalOpen])

    // Track when Insurance Modal opens/closes
    useEffect(() => {
        if (insuranceModalOpen) {
            setCurrentModalStep(3.6) // Verify Insurance Details Modal
        } else if (currentModalStep === 3.6) {
            setCurrentModalStep(null)
        }
    }, [insuranceModalOpen])

    const { sessionId, markAsSubmitted, trackNoProviders, trackPatientNotFoundAbandonment } = useJourneyTracking({
        trackingEnabled: (findYourCareValues.bookingWith === 'yes' || findYourCareValues.bookingWith === 'no') 
                     && (amdPatientDetails?.id || PatientCreateObject?.first_name), // Track when we have patient data
    userType: findYourCareValues.bookingWith === 'yes' ? 'existing' : 'new',
    currentStep: getCurrentStepWithModal(),
    careType: findYourCareValues.lookingFor,
    language: selectedLanguage || getLangCode(window.location.hash),
    stepName: getStepName(getCurrentStepWithModal()),
    patientData: amdPatientDetails?.id ? amdPatientDetails : PatientCreateObject,
    providerData: { count: careTeamFlow ? (careTeamProviderCount || 0) : (providerCount || 0) },
    specialty: careTeamFlow ? careTeamSpecialty : (selctedProviderDetails?.specialities?.[0]?.label || ''),
    isRegistered: findYourCareValues.bookingWith === 'yes',
    appType: careTeamFlow ? 'follow_up' : (findYourCareValues.lookingFor ? 'initial' : null),
    selectedTime: selectedTime,
    })
        

    useEffect(() => {
        const handleResize = () => {
          setIsMobileView(window.innerWidth < 768);
        };
      
        // Run on mount to set the initial state
        handleResize();
      
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
      

    const isTablet = useMediaQuery((theme) =>
        theme.breakpoints.down('lg'),
    );

    const intakeFormObjectToArrayConvert = (objectValues = null) => {
        if (!objectValues) return []
        const returnArray = []
        Object.keys(objectValues).forEach((keyItem) => {
            if (objectValues[keyItem])
                returnArray.push(`${keyItem?.charAt(0)?.toUpperCase()}${keyItem.substring(1)}`)
        })
        return returnArray
    }

    const intakeFormFormik = useFormik({
        initialValues: INTAKE_FORM_INIT_VALUES,
        // onSubmit: handleSubmitIntakeForm,
        validationSchema: intakeFormValidation,
    })
    const intakeFormNewFormik = useFormik({
        initialValues: INIT_VALUES_NEW,
        validationSchema: intakeFormValidationnew,
    })

    const handleSubmitIntakeForm =  (callback) => {
        setReviewAppointmentLoader(true)
        setIsLoading(true)
        const values = intakeFormFormik?.values
        const intakeFormPayload = {
            patient_id: amdPatientDetails?.id,
            term_signed: amdPatientDetails?.middle_name ? amdPatientDetails?.first_name +' '+ amdPatientDetails?.middle_name + ' ' + amdPatientDetails?.last_name : amdPatientDetails?.first_name +' ' + amdPatientDetails?.last_name,
            // timezone: userData?.timezone || 'us/pacific',
            medications: removeEmptyObjects(medications),
        }

        addIntakeForm(intakeFormPayload)
            ?.then((res) => {
                callback()
            })
            ?.catch(() => {
                notification("couldn't add intake form!", 'error')
            })
    }

    const handleFindYourCareValues = (value, fieldName) => {
        setFindYourCareValues((state) => {
            return {
                ...state,
                [fieldName]: value,
            }
        })
        if(fieldName  == 'bookingWith' && value == 'no'){
            setPatientCheckExist(true)
        }
    }
    const handleSelectATimeValues = (value, fieldName) => {
        setSelectSelectATimeValues((state) => {
          if (fieldName === 'date' && state.evening && isWeekend(value)) {
            return {
              ...state,
              date: value,
              morning: false,
              afternoon: false,
              evening: false,
            };
          }else if(fieldName === 'date' && value.isSame(moment().tz('US/Pacific'), 'day')){
             const checkedValue = checkTimeForToday()
             return{
                ...state,
                morning: checkedValue?.morning ? false : state?.morning,
                afternoon: checkedValue?.afternoon ? false : state?.afternoon,
                evening: checkedValue?.evening ? false : state?.evening,
                date: value,
             }
          }
          return {
            ...state,
            [fieldName]: value,
          };
        });
    }
    const handleExistPatientForm = (value, fieldName) => {
        setPatientexistForm((state) => {
            return {
                ...state,
                [fieldName]: value,
            }
        })
    }
    const handleSelectDisableTime = ( value) => {
        setCheckDisableTime(value)
    }

    const handleChangeHeaderTab = () => {
        dispatch(changeHeaderTab(reversedHeaderConstants[Routes.DASHBOARD.split('/')[1]]))
    }

    const flattenAppointmentDetailsResponse = (data) => {
        if (!data) return
        return {
            providerName: `${selctedProviderDetails?.first_name} ${selctedProviderDetails?.last_name}`,
            speciality: selctedProviderDetails?.specialities[0]?.label,
            date: data?.date ? moment(data?.date).format('MMMM Do, YYYY') : 'N/A',
            startTime: data?.start
                ? patientTimeZone(data?.start, timeZoneOfPatient || 'US/Pacific').format('h:mm A')
                : 'N/A',
            endTime: data?.end
                ? patientTimeZone(data?.end, timeZoneOfPatient || 'US/Pacific').format('h:mm A')
                : 'N/A',
        }
    }
    const handleBookAppointment = async (callback) => {
        setReviewAppointmentLoader(true)
        const date = amdPatientDetails?.dob
        const [mm, dd, yyyy] = date.split("/"); 
        const formatted = `${yyyy}-${mm}-${dd}`;

        const bookAppointmentPayload = {
            date: patientTimeZone(selectedTime?.start_time, timeZoneOfPatient)?.format('YYYY-MM-DD'),
            end_time: patientTimeZone(selectedTime?.end_time, timeZoneOfPatient)?.format('HH:mm'),
            start_time: patientTimeZone(selectedTime?.start_time,timeZoneOfPatient)?.format('HH:mm'),
            appointment_type: 'Telehealth Visit',
            reason_for_visit: reasonForVisitText,
            internal_note: '',
            specialty: selctedProviderDetails?.specialities[0],
            specialty_id: providerVisitType?.specialty_id,
            location_id: config.dev.appointmentLocationId,
            duration: providerVisitType?.duration || moment(selectedTime?.end_time).diff(moment(selectedTime?.start_time), 'minutes'),
            visit_type_id: providerVisitType?.id,
            patient_id: amdPatientDetails?.id,
            practitioner_id: selctedProviderDetails?.id,
            supervising_provider: selctedProviderDetails?.supervising_physician,
            is_require_translator: selectedLanguage == 'es' ? true : false,
            appointment_status: 'Appt_Not_Start',
            is_reoccurring_appointment: false,
            days: [],
            end_date: '',
            unit: '',
            once_every: '',
            end_type: '',
            timezone: timeZoneOfPatient || 'US/Pacific',
            patientName: `${amdPatientDetails?.first_name} ${amdPatientDetails?.last_name}`,
            practitioner_first_name: selctedProviderDetails?.first_name,
            practitioner_last_name: selctedProviderDetails?.last_name,
            populate: false,
            reoccuring_created: false,
            color_tag: providerVisitType?.color_tag,
            clinical_note_id: '',
            notes: [],
            note: '',
            noteView: 'no-view',
            start: selectedTime?.start_time,
            end: selectedTime?.end_time,
            appointment_for: 'patient',
            participants: [
                {
                    status: 'accepted',
                    role: 'Patient',
                    participant_id: amdPatientDetails?.id,
                },
            ],
            status: 'pending',
            first_given_date: offeredDate?.first_given_date,
            second_given_date: offeredDate?.second_given_date,
            third_given_date: offeredDate?.third_given_date,
            chart: amdPatientDetails?.chart,
            harming_yourself: findYourCareValues?.lookingFor?.toLowerCase().startsWith('psychiatry') && intakeFormNewFormik?.values?.harmingYourself ? intakeFormNewFormik?.values?.harmingYourself : null,
            harming_others: findYourCareValues?.lookingFor?.toLowerCase().startsWith('psychiatry') && intakeFormNewFormik?.values?.harmingOthers ? intakeFormNewFormik?.values?.harmingOthers : null,
            dob: formatted
        }
        try {
            
            setIsLoading(true)
            if(patientHaveInsuranceExist && originalInsurance && currentInsurance && hasInsuranceChanged(originalInsurance, currentInsurance))
            {
                const insurancePayload = {
                    patient_id: amdPatientDetails?.id,
                    first_name: amdPatientDetails?.first_name,
                    last_name: amdPatientDetails?.last_name,
                    carrier_id: currentInsurance.insurance_Id,
                    responsible_party: responsible_partyrecieved,
                    subscriber_id: currentInsurance.subscriber_id,
                    group_name: currentInsurance.group_name,
                    group_number: currentInsurance.group_number,
                    relationship_id: currentInsurance.relationShip?.key,
                    front_card_data: patientInsuranceFront
                    ? await convertFileToPdfBase64(patientInsuranceFront)
                    : '',
                    back_card_data: patientInsuranceBack
                    ? await convertFileToPdfBase64(patientInsuranceBack)
                    : '',
                };

                const isInsuranceNameChanged = String(originalInsurance.insurance_Id) !== String(currentInsurance.insurance_Id);

                if (isInsuranceNameChanged) {
                    await createInsurance(insurancePayload);
                } else {
                    await updateInsurance(insurancePayload);
                }
            }
            
            const appointMentCreateResult = await newBookAppointment(bookAppointmentPayload)
            setAppointmentDetails(
                flattenAppointmentDetailsResponse(appointMentCreateResult.data.data),
            )
            // if (
            //     !appointMentCreateResult?.data?.status &&
            //     appointMentCreateResult?.data?.error === 'Appointment slot is already booked!'
            // ) {
            //     notification(appointMentCreateResult?.data?.error)
            //     setReturnedErrorMessage(true)
            //     setReviewAppointmentLoader(false)
            //     setIsLoading(false)
            //     setSteps(3)
            //     return
            // }
            notification('Appoinment is booked succesfully!', 'success')

            // Mark appointment as submitted to prevent abandonment tracking
            markAsSubmitted()

            if (findYourCareValues.bookingWith === 'yes') {
                handleSubmitIntakeForm(callback);
            } else {
                callback();
            }
        } catch (e) {
            notification(e?.data?.message || 'Something went wrong!', 'error')
            setSteps((state) => {
                return Math.floor(state)
            })
            setIsLoading(false)
            setReviewAppointmentLoader(false)
        }
    }
    const handleNewIntakeFormCreate = async () => {
        const intakeForm = {
            patient_id: amdPatientDetails?.id,
            questions: [
                {
                    question: 'Is patient a minor?',
                    answer: intakeFormNewFormik?.values?.minor,
                },
                {
                    question: 'Do you have any current or pending legal issues or are being advised by a court judge, parole officer, or CPS to seek mental health care or assessment?',
                    answer: intakeFormNewFormik?.values?.careOrAssessment,
                },
                {
                    question: 'Please select if you have ever experienced or suffered from any of the following in the past or present?\n(check that applies)',
                },
                {
                    question: 'Have you had thoughts of harming yourself?',
                    answer: [intakeFormNewFormik?.values?.harmingYourself],
                },
                {
                    question: 'Have you had thoughts of harming others?',
                    answer: [intakeFormNewFormik?.values?.harmingOthers],
                },
                {
                    question: 'Have you struggled with alcohol abuse?',
                    answer: [intakeFormNewFormik?.values?.alcoholAbuse],
                },
                {
                    question: 'Have you struggled with substance abuse?',
                    answer: [intakeFormNewFormik?.values?.substanceAbuse],
                },
            ],
            term_signed: amdPatientDetails?.middle_name ? amdPatientDetails?.first_name +' '+ amdPatientDetails?.middle_name + ' ' + amdPatientDetails?.last_name : amdPatientDetails?.first_name +' ' + amdPatientDetails?.last_name,
            timezone: timeZoneOfPatient,
            // specialty: selctedProviderDetails?.specialities[0]?.toLowerCase(),
            specialty: 'Psychiatry'
        }
        const intakeFormTherapy = {
            patient_id: amdPatientDetails?.id,
            questions: [
                {
                    heading:'Consent for Therapy with an Associate Therapist',
                    paragraph:'I understand that I will be receiving therapy services from an Associate Therapist who is currently completing the required clinical hours to obtain full licensure as an independent therapist/counselor in the state of California. To meet the licensure requirements set by the California Board of Behavioral Sciences (BBS), Associate Therapists must complete 3,000 supervised hours under the guidance of a qualified clinical supervisor approved by the Board. This supervision is essential for professional development and progression toward independent licensure.'
                },
                {
                    paragraph:'I acknowledge that therapy services will be based on a relationship built on trust and respect. Together, we will identify goals for therapy and work collaboratively toward achieving them. Sessions may involve exploring thoughts, emotions, personal history, communication patterns, beliefs, and areas for personal growth.'
                },
                {
                    paragraph:'As part of the training process, the Associate Therapist may consult with their supervisor regarding my case to ensure I receive the highest quality of care. Additionally, there may be occasions when a supervisor observes a portion of my therapy sessions for training and quality assurance purposes. Observations may occur in person or via a secure video link. The supervisor will not actively participate in the session but will provide feedback to support the therapist’s clinical growth. I will be informed in advance if a supervisor will be present in a session.'
                },
                {
                    paragraph:'I understand that live observation enables the Associate Therapist to gain skills and allows their supervisor to assess, evaluate, and better understand their abilities. Both the Associate Therapist and their supervisor are bound by HIPAA and all applicable confidentiality laws. Any information shared during supervision or observation will remain strictly confidential and will only be used for professional development and supervisory purposes. No audio or video recording of these sessions will take place.'
                },    
                {
                    paragraph:'I have the right to decline observation at any time, and my decision will not impact my treatment. If an observation is scheduled, I will be informed in advance.'
                }, 
                {
                    paragraph:'I have the right to know who is involved in my care. At the time of my appointment, I will be provided with the name and license number of the clinical supervisor for my reference.'
                }, 
                {
                    paragraph:'To ensure I am comfortable with my provider, I also have the ability to review a full list of providers by visiting: https://www.telemed2u.com/our-providers.'
                }, 
                {
                    paragraph:'By signing below, I acknowledge that I have read and understood this consent form and agree to receive therapy services from an Associate Therapist under supervision. I agree that my electronic signature on this application is binding and enforceable, as if I had signed a paper copy.'
                }, 
                {
                    heading:'Psychotherapy Consent',
                    paragraph:'I, the patient, consent to participate in telemental health services with a TeleMed2U provider as part of my psychotherapy. I understand that telemental health involves the delivery of clinical health care services through technology-assisted communication between a provider and a patient in different locations.'
                },
                {
                    subheading:'I understand the nature of counseling:'
                },
                {
                    paragraph:'The scope and type of counseling services I receive will be determined through an initial assessment and collaborative discussion with my provider. Counseling is a structured process designed to support personal growth, enhance emotional well-being, and improve interpersonal relationships. Research indicates that counseling can lead to increased self-awareness, improved coping strategies, and a greater ability to navigate life’s challenges.'
                },
                {
                    paragraph:'While counseling offers many benefits, including greater emotional resilience and personal insight, it may also bring about difficult emotions as I confront personal experiences and patterns. Emotional discomfort, temporary distress, or shifts in relationships may occur as part of the therapeutic process. My provider will work with me to navigate these challenges and develop strategies to promote positive change while minimizing potential risks.'
                },
                {
                    subheading:'I understand the following with respect to telemental health:'
                },
                {
                    paragraph:'1. Information About Your Provider – a provider will be assigned to you based on your needs and treatment goals to ensure alignment with the provider’s area of expertise. You may or may not continue with the same therapist after your intake is complete, as your ongoing provider will be determined based on clinical considerations and your preferences. TeleMed2U has both independently licensed therapists and associate therapists. If you are scheduled with an associate therapist, you will be required to sign an additional consent form acknowledging their supervision process.'
                },
                {
                    paragraph:'2. Right to Withdraw Consent – I have the right to withdraw consent for telemental health services at any time without affecting my right to future care, services, or program benefits to which I would otherwise be entitled.'
                },
                {
                    paragraph:'3. Risks and Benefits – I understand there are potential risks, benefits, and consequences associated with telemental health, including but not limited to technical disruptions, confidentiality breaches, and limitations in responding to emergencies.'
                },
                {
                    paragraph:'4. Confidentiality & Recording – I understand that neither party will record any of the online sessions. All information shared during sessions and any written records related to those sessions are confidential and will not be disclosed to anyone without written consent, unless disclosure is required or permitted by law.'
                },
                {
                    paragraph:'5. Minors & Confidentiality – If I am under 18, the same privacy laws apply, with mandated reporting exceptions as detailed below.'
                },
                {
                    paragraph:'6. Privacy Laws & Exceptions – The privacy laws protecting my protected health information (PHI) apply to telemental health unless an exception applies, such as mandatory reporting for abuse, risk of harm to self or others, or involvement in legal proceedings.'
                },
                {
                    paragraph:'7. Confidentiality and Duty to Warn – Discussions between a provider and a patient are confidential. Under the Health Insurance Portability and Accountability Act (HIPAA), my private information cannot be shared without my written consent. This means that what I share with my provider remains private unless I sign a document authorizing disclosure to a specific person (e.g., a family member or another doctor).'
                },
                {
                    paragraph:'8. Privacy and My Session Environment – Because telemental health does not occur in person, I understand that I am responsible for ensuring a private and secure session environment. TeleMed2U providers take reasonable steps to protect my privacy, but I should also find a confidential space where I will not be interrupted or overheard.'
                },
                {
                    paragraph:'9. Drug and Alcohol Use – My provider and I have the right to expect that our sessions will occur while both parties are not under the influence of any substance (prescribed, over-the-counter, unprescribed, legal, recreational, or illegal). If a party appears impaired, the session may be terminated, and an incident report will be submitted for further review. If substance use is a factor in treatment, my provider will work with me to develop a plan to address it within the safety planning discussion.'
                },
                {
                    paragraph:'10. Session Environment & Driving – I should have a safe and quiet space for sessions, ensuring there are no distractions or third-party interruptions. Both my provider and I should position our cameras at eye level for clear visibility and effective communication. Sessions can take place while using a phone in the event of technical disruptions, and no one should actively drive during a session for safety reasons and compliance with distracted driving laws.'
                },
                {
                    paragraph:'11. Respectful Conduct – TeleMed2U expects all interactions to be based on mutual respect, fostering a trusting and collaborative relationship between patients, providers, and staff. Disruptive, disrespectful, or discriminatory behavior will not be tolerated and may result in the termination of services.'
                },
                {
                    paragraph:'12. Crisis management and intervention – Telemental health services are not appropriate for individuals in crisis who require a high level of support and intervention. My provider will assess whether I am a suitable candidate for telemental health services. If I later experience a crisis, my provider will implement an emergency plan to address the situation and may refer me to a higher level of care.'
                },
                {
                    paragraph:'13. Emergency Communications – Telemental health services are not intended for medical or mental health emergencies. I should not delay seeking medical attention based on my sessions. If I believe I am experiencing an emergency, I should call 911 or 988 (Mental Health Crisis Line) immediately. If, at any time during a session, I experience a medical or mental health crisis that cannot be managed remotely, my provider may determine that telemental health services are no longer appropriate. In this case, I may be instructed to seek in-person care, and my provider may contact emergency services or my identified emergency contact if necessary.'
                },
                {
                    paragraph:'14. Patient Feedback – TeleMed2U strives to provide high-quality care and may follow up after my appointment for feedback. If I have concerns, I can contact TeleMed2U at 512-382-1933 or via email at info@telemed2u.com. If a CalOptima patient, contact 562-268-0955 or via email at caloptimabh@telemed2u.com.'
                },
                {
                    paragraph:'15. Appointment Reminders – TeleMed2U uses email, text, and phone call reminders for appointments. I may request my provider or customer service to change my preferences at any time.'
                },
                {
                    subheading:'Why do I need to sign this if I am not getting therapy from you?'
                },
                {
                    paragraph:'While you may not be receiving therapy at this moment, signing this consent form is necessary in case you and your provider decide to include therapy as part of your personalized treatment plan in the future. If therapy is added, it will be provided by one of our licensed therapists, and having this consent on file ensures we can proceed with treatment.'
                },
                {
                    paragraph:'I agree that my electronic signature on this application is binding and enforceable, as if I had signed a paper copy.'
                },
            ],
            term_signed: amdPatientDetails?.middle_name ? amdPatientDetails?.first_name +' '+ amdPatientDetails?.middle_name + ' ' + amdPatientDetails?.last_name : amdPatientDetails?.first_name +' ' + amdPatientDetails?.last_name,
            timezone: timeZoneOfPatient,
            specialty: 'Therapy'
        }
        try {
            setIsLoading(true)
            const res = await addIntakeFormNew(selctedProviderDetails?.specialities[0]?.toLowerCase() == 'therapy' ? intakeFormTherapy : intakeForm)
            setSteps((state) => {
                setIsLoading(false)
                setReviewAppointmentLoader(false)
                return Math.floor(4)
            })
        } catch (e) {
            notification('Something went wrong!', 'error')
            setSteps((state) => {
                setIsLoading(false)
                setReviewAppointmentLoader(false)
                return Math.floor(4)
            })
        }
    }

    const scrollTop = () => {
        stepperRef.current.parentElement.parentElement.scrollTop = 0
    }
    const showCalendar = () =>{
        setSteps(3)
    }
    
    const handleNextStep = () => {
        if (steps === 4) {
            window.open('https://www.telemed2u.com/', '_self')
            // setSteps(7)
            // history.push(Routes.DASHBOARD)
            // handleChangeHeaderTab()
        } else {
            scrollTop()
            if( steps === 1 ){
                // setSteps(1.5)
                if(selfpay || patientHaveInsurance){
                    handleCheckPatientFound('fromCreatePatient')
                    setFindYourCareValues((state) => {
                        return {
                            ...state,
                            lookingFor: '',
                        }
                    })
                }else{
                    setErrorMessageforRadio(true)
                }
                // setSelectSelectATimeValues((state) => {
                //     return {
                //         ...state,
                //         morning: false,
                //         afternoon: false,
                //         evening: false,
                //         date: moment().tz('US/Pacific'),
                //     }
                // })
            } else {
                // Both initial (steps=3) and follow-up (steps=3.5) open AppointmentPostBookingModal
                if ((steps === 3 || steps === 3.5) && providerVisitType?.id && Object.keys(selectedTime).length > 0) {
                    if (['PSYINT','PSYCHILDINT','THERAPYINT'].includes(providerVisitType.id.split(',')[0])) {
                        intakeFormNewFormik.resetForm()
                        setCheckboxTherapyConsent(false)
                        setTherapyConsentStep(1)
                    }
                    setPostBookingStep(steps)
                    setOpenPostBookingModal(true)
                    return
                }

                if (steps === 3.5)
                {
                    if (patientHaveInsurance)
                    {
                        setSteps(3.6)
                        } else {
                        if (findYourCareValues.bookingWith === 'yes') {
                            formik.handleSubmit()
                        } else {
                            updatePatient()
                        }
                    }
                } else {
                    setSteps((state) => {
                        if (state === 0) return 0.5
                        if (findYourCareValues.bookingWith !== 'yes' && state === 0.5) return 2 //condition for intake form step
                        if (state === 0.5) return 1
                        if (state === 1.5)
                        {
                            let selectedCarrier = insuranceFormik?.values?.carrier;

                            if (selectedCarrier) 
                            {

                                // carrierList contains providers array from backend
                                const matchedCarrier = carrierList.find(
                                    (item) => String(item?.id)=== String(selectedCarrier?.id) || String(item?.['@id']) === String(selectedCarrier?.['@id'])
                                );

                                if (matchedCarrier && matchedCarrier.providers) {
                                    setSelectedProviderIds(matchedCarrier.providers);
                                } else {
                                    setSelectedProviderIds([]);
                                }
                                const insuranceReduxPayload = {
                                    carrier: selectedCarrier,
                                    insurance_Id: selectedCarrier?.['@id'],
                                    insurance_name: selectedCarrier?.['@name'],
                                    subscriber_id: insuranceFormik.values.subscriber_id,
                                    subscriberNum: insuranceFormik.values.subscriber_id,
                                    group_name: insuranceFormik.values.group_name,
                                    group_number: insuranceFormik.values.group_number,
                                    relationShip: insuranceFormik.values.relationShip,
                                    patientInsuranceFront: patientInsuranceFront,
                                    patientInsuranceBack: patientInsuranceBack,
                                };

                                dispatch(setUpdateInsuranceDetails(insuranceReduxPayload));
                            }
                             return 2
                        }
                        if (state === 3) return 3.5
                        if (state === 2) {
                            setShowStateConfirmModal(true)
                            return 2
                        }
                        return state + 1
                    })
                }
            }
        }
    }
    const handlePreviousStep = () => {
        dispatch(handleClickOnContinue(false))
        // setPatientFoundLoading(false)
        if (steps === 0) {
            history.push(Routes.DASHBOARD)
            handleChangeHeaderTab()
        } else {
            scrollTop()
            // Reset insurance form state when going back from insurance form to patient form
            if (steps === 1.5) {
                setSelfpayInInsurance(false)
                insuranceFormik.resetForm()
                setSelectedProviderIds([])
                setCurrentInsurance(null)
                dispatch(setUpdateInsuranceDetails({}))
            }
            setSteps((state) => {
                if (findYourCareValues.bookingWith !== 'yes' && state === 2) return 0.5
                if (findYourCareValues.bookingWith == 'yes' && patientHaveInsurance && state === 2) return 1.5
                if (findYourCareValues.bookingWith == 'yes' && !patientHaveInsurance && state === 2) return 1
                if (state === 1.5) return 1
                if (state === 1) return 0.5
                if (state === 0.5) return 0
                // if (state === 3 ) return 4
                if (state === 3.5) return 3
                if (state === 3) return 2
                return state - 1
            })
        }
    }

    const handleSubmitNewPatient = () => {
        return ''
    }

    const newPatientFormik = useFormik({
        initialValues: NEW_PATIENT_FORM_INIT_VALUES,
        onSubmit: handleSubmitNewPatient,
        validationSchema: newPatientFormValidation,
    })

    const intakeFormOnChange = (fieldName, value) => {
        intakeFormFormik.setFieldValue(fieldName, value)
        setIntakeFormTouchedFields((state) => ({
            ...state,
            [fieldName]: value,
        }))
    }
    const intakeFormOnChangeNew = (fieldName, value) => {
        intakeFormNewFormik.setFieldValue(fieldName, value)
    }

    const validationSchema = yup.object({
        first_name: yup.string().required('First name is required!'),
        last_name: yup.string().required('Last name is required!'),
        dob:  yup.string()
        .nullable() 
        .matches(
            /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
            'Date must be in MM/DD/YYYY format'
          )
        .test(
        'dob-not-in-future',
        'Date must not be greater than today',
        function (value) {
            if (!value) return true; // allow empty for nullable
            const [month, day, year] = value.split('/');
            const enteredDate = new Date(year, month - 1, day);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return enteredDate <= today;
        }
        )
        .required('Date of Birth is required!'),
        phone_number: yup
            .string()
            .matches(USPhoneRegex, 'Invalid phone number!')
            .required('Phone is required!'),
        email: yup.string().email('Invalid email!').required('Email is required!'),
        // sex: yup.string().required('Sex is required!'),
        gender: yup.string().required('Gender is required!'),
        timeZone: yup.string().required('Time Zone is required!'),
        address_one: yup.string().required('Street Address is required!'),
        city: yup.string().required('City is required!'),
        zip_code: yup
        .string()
        .matches(zipCodeRegex, 'Not a valid zip code')
        .required('Zip Code is required!'),
        state: yup.string().required('State is required!')
        

    })
    const getSex = (value) => {
        const lowvalue = value?.toLowerCase().trim();
        if (lowvalue.includes("transgender male") || lowvalue === "male") {
            return "male";
        } else if (lowvalue.includes("transgender female") || lowvalue === "female") {
            return "female";
        } else {
            return "other";
        }
    }
    const handleSubmit = async(values) =>{
        const updatedPayload = {
                "first_name": values.first_name.trim(),
                "last_name" : values.last_name.trim(),
                "middle_name" : values.middle_name,
                "preferred_name" : values.preferred_name,
                "dob" : values.dob,
                "phone" : values.phone_number.trim(),
                "email" : values.email.trim(),
                "sex" : getSex(values?.sex) , 
                "address1" : values.address_one.trim(),
                "address2" : values.address_two.trim(),
                "city" : values.city,
                "state" : values.state,
                "zip" : values.zip_code.trim(),
                "genderidentity":values?.gender,
                "orientation" :values?.orientation,
                "language" :values?.preferredlanguage?.id,
                "ethnicity":values?.ethnicity?.key,
                "races":values?.race?.key,
                "providerid": selctedProviderDetails?.id,
                "timezone": values?.timeZone
        }
        try {
            setIsLoading(true)
            setFromCreate(false)
            const patientCreate = await tm2uPatientCreate(updatedPayload)
            if(patientCreate.status === 200){
                dispatch(setAMDpatientCreate(patientCreate.data.patient))
                setFromCreate(true)
            }
        }catch (e) {
            if(e.status === 409){
                setDuplicatePatientAlert(true)
                setSteps(1)
            }else{
                notification('Something went wrong!', 'error')
                setSteps(3)
            }
            setIsLoading(false)
        } 
    }
    const formik = useFormik({
        initialValues: INITIAL_VALUES_PATIENT,
        enableReinitialize: true,
        validationSchema,
        onSubmit: handleSubmit,
    })
    const validationSchemaForInsurance = yup.object({
        carrier:  yup
        .object()
        .nullable() // allow nulls in schema
        .required('Carrier name is required!'),
        subscriber_id: yup.string().required('Subscriber id is required!'),
        relationShip: yup.object().nullable().required('Relationship to Insured is required!'),
    })
     // Helper function to check if insurance data has changed
    const hasInsuranceChanged = (original, current) => {
        if (!original || !current) return false;

        return (
            original.insurance_Id !== current.insurance_Id ||
            original.subscriberNum !== current.subscriberNum ||
            original.group_name !== current.group_name ||
            original.group_number !== current.group_number ||
            original.relationship?.key !== current.relationship?.key ||
            original.patientInsuranceFront !== current.patientInsuranceFront ||
            original.patientInsuranceBack !== current.patientInsuranceBack
        );
    };

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file); // gives "data:<type>;base64,<data>"
          reader.onload = () => {
            // Remove the "data:<type>;base64," prefix
            const base64Data = reader.result.split(",")[1];
            resolve(base64Data);
          };
          reader.onerror = (error) => reject(error);
        });
    };
    const loadImage = (dataUrl) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = dataUrl;
        });
    };
    // Compress image (PNG/JPG) before converting to PDF
    const compressImage = (dataUrl, maxWidth = 1200, quality = 0.6) => {
        return new Promise((resolve) => {
            const img = new Image()
            img.onload = () => {
                const canvas = document.createElement('canvas')

                let width = img.width
                let height = img.height

                // Resize if width too large
                if (width > maxWidth) {
                    height *= maxWidth / width
                    width = maxWidth
                }

                canvas.width = width
                canvas.height = height

                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)

                // Convert to JPEG for small size
                const compressed = canvas.toDataURL('image/jpeg', quality)
                resolve(compressed)
            }
            img.src = dataUrl
        })
    }
    const convertFileToPdfBase64 = async (file) => {

        // Convert original file to base64
        const base64 = await convertToBase64(file.src?.file);
      
        // If already PDF → return same base64
        if (file.type === "application/pdf") {
          return base64;
        }
      
        // IMAGE → PDF
        if (
          file.type === "image/jpeg" ||
          file.type === "image/jpg" ||
          file.type === "image/png"
        ) {
          let dataUrl = `data:${file.type};base64,${base64}`;
      
          // STEP 1: COMPRESS (VERY IMPORTANT)
          // first compression - resize + quality reduce
          let compressedUrl = await compressImage(dataUrl, 1200, 0.9);
      
          const pdf = new jsPDF("p", "pt", "a4");
      
          // load compressed image into PDF
          const img = await loadImage(compressedUrl);
      
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
      
          const ratio = Math.min(pageWidth / img.width, pageHeight / img.height);
          const w = img.width * ratio;
          const h = img.height * ratio;
      
          const x = (pageWidth - w) / 2;
          const y = (pageHeight - h) / 2;
      
          pdf.addImage(img, "JPEG", x, y, w, h);
      
          // PDF → Base64 (no prefix)
          let pdfData = pdf.output("datauristring").split(",")[1];
      
          // Calculate PDF size (MB)
          let pdfSizeMB = Math.ceil((pdfData.length * 3) / 4 / (1024 * 1024));
      
          // STEP 2: If still >10MB → compress more
          if (pdfSizeMB > 10) {
      
            const moreCompressedUrl = await compressImage(dataUrl, 900, 0.9);
      
            const pdf2 = new jsPDF("p", "pt", "a4");
            const img2 = await loadImage(moreCompressedUrl);
      
            const ratio2 = Math.min(
              pageWidth / img2.width,
              pageHeight / img2.height
            );
      
            pdf2.addImage(
              img2,
              "JPEG",
              x,
              y,
              img2.width * ratio2,
              img2.height * ratio2
            );
      
            pdfData = pdf2.output("datauristring").split(",")[1];
          }
      
          return pdfData;
        }
    };
    const applyInsuranceUpdate = (updatedData) => {

    insuranceFormik.setValues({
        carrier: carrierList.find(c => String(c?.['@id']) === String(updatedData?.insurance_Id)),
        subscriber_id: updatedData?.subscriber_id,
        group_name: updatedData?.group_name,
        group_number: updatedData?.group_number,
        relationShip: updatedData?.relationship,
    })

    setCurrentInsurance({
        insurance_Id: updatedData.insurance_Id,
        insurance_name: updatedData.insurance_name,
        subscriber_id: updatedData.subscriber_id,
        subscriberNum: updatedData.subscriber_id,
        group_name: updatedData.group_name,
        group_number: updatedData.group_number,
        relationShip: updatedData.relationship,
        patientInsuranceFront: updatedData.patientInsuranceFront,
        patientInsuranceBack: updatedData.patientInsuranceBack,
    })

    const matchedCarrier = carrierList.find(
        (item) => String(item?.['@id']) === String(updatedData?.insurance_Id)
    )

    setSelectedProviderIds(matchedCarrier?.providers || [])
}

// Full-replace dispatch — clears every insurance field so stale values
// from a failed/cancelled update don't bleed through the merged Redux state.
const dispatchInsuranceReset = (insData) => {
    dispatch(setUpdateInsuranceDetails({
        insurance_Id:         insData?.insurance_Id         || '',
        insurance_name:       insData?.insurance_name       || null,
        carrier:              insData?.carrier              || null,
        subscriber_id:        insData?.subscriber_id        || '',
        subscriberNum:        insData?.subscriberNum        || insData?.subscriber_id || '',
        group_name:           insData?.group_name           || '',
        group_number:         insData?.group_number         || '',
        relationship:         insData?.relationship         || null,
        relationShip:         insData?.relationShip         || null,
        member_name:          insData?.member_name          || null,
        member_dob:           insData?.member_dob           || null,
        patientInsuranceFront:insData?.patientInsuranceFront|| null,
        patientInsuranceBack: insData?.patientInsuranceBack || null,
        responsible_party:    insData?.responsible_party    || '',
    }))
}
const handleSelectNewProvider = () => {
    const hasProviders = selectedProviderIds && selectedProviderIds.length > 0

    setSelectedProviderDetails({})
    setSelectedTime({})
    setProviderCredentialModalOpen(false)
    setOpenPostBookingModal(false)

    if (hasProviders) {
        // New insurance has providers → show SelectAProviderInt filtered by those IDs
        if (pendingInsuranceUpdate) {
            applyInsuranceUpdate(pendingInsuranceUpdate)
        }
        setPendingInsuranceUpdate(null)
        setSteps(3)
    } else {
        // No providers for this insurance at all → revert insurance + care team
        dispatchInsuranceReset(originalInsurance)
        setPendingInsuranceUpdate(null)
        setSteps(2)
    }
}

const validateProviderInsuranceCredential = (insuranceId) => {
    if (!careTeamFlow) return true;

    const providerId = selctedProviderDetails?.id;
    if (!providerId || !insuranceId) return true;

    const insuranceNameChanged =
        originalInsurance?.insurance_Id &&
        String(originalInsurance?.insurance_Id) !== String(insuranceId);

    // If insurance name not changed → don't validate credential
    if (!insuranceNameChanged) {
        return true;
    }

    const matchedCarrier = carrierList.find(
        (item) => String(item?.['@id']) === String(insuranceId)
    );

    const providerAccepted = matchedCarrier?.providers?.some(
        id => String(id) === String(providerId)
    );

    if (!providerAccepted) {
        setSelectedProviderIds(matchedCarrier?.providers || []);
        setProviderCredentialModalOpen(true);
        return false;
    }

    return true;
};

    const handleInsuranceSubmit = async()=>{
        try{
            
            setIsLoading(true)
            setReviewAppointmentLoader(true)
            const checkValue = 'SELF pay'
            const self = carrierList.find(
                            (item) => item?.['@name']?.toLowerCase() === checkValue?.toLowerCase()
                        )
            
            const payload =  selfpay ? {
                "patient_id": amdPatientDetails?.id,
                "carrier_id": self['@id'],
                "responsible_party": amdPatientDetails?.responsible_party,
                "group_name": '',
                "group_number": '',
                "relationship_id": '18',
                "subscriber_id": '00000',
                "first_name": amdPatientDetails?.first_name,
                "last_name": amdPatientDetails?.last_name,
            } :
            {
                "patient_id": amdPatientDetails?.id,
                "carrier_id": insuranceFormik?.values?.carrier['@id'],
                "responsible_party": amdPatientDetails?.responsible_party,
                "group_name": insuranceFormik?.values?.group_name,
                "group_number": insuranceFormik?.values?.group_number,
                "relationship_id": insuranceFormik?.values?.relationShip?.key,
                "subscriber_id": insuranceFormik?.values?.subscriber_id,
                "first_name": amdPatientDetails?.first_name,
                "last_name": amdPatientDetails?.last_name,

                "front_card_type": patientInsuranceFront?.type ? 'application/pdf' : '',
                "front_card_data": patientInsuranceFront?.src?.file ? await convertFileToPdfBase64(patientInsuranceFront) : '',
                "back_card_type": patientInsuranceBack?.type ? 'application/pdf' : '',
                "back_card_data": patientInsuranceBack?.src?.file ? await convertFileToPdfBase64(patientInsuranceBack) : ''

            }
            const insuranceIdToValidate = selfpay
                ? self['@id']
                : insuranceFormik?.values?.carrier?.['@id'];

            const isValid = validateProviderInsuranceCredential(insuranceIdToValidate);

            if (!isValid) {
                setIsLoading(false);
                setReviewAppointmentLoader(false);
                return;
            }
            const baseURL = process.env.REACT_APP_SONORA_V2_API_URL
            const res = await axios.post(`${baseURL}/cov2_insurance/`, payload, {
                headers: {
                  "Content-Type": "application/json",
                },
              });
        }catch(error){
            console.log("error",error)
        }finally{
            handleBookAppointment(() => {
                if(providerVisitType?.id.split(",")[0] == 'PSYINT' || providerVisitType?.id.split(",")[0] == 'PSYCHILDINT' || providerVisitType?.id.split(",")[0] == 'THERAPYINT'){
                    handleNewIntakeFormCreate()
                }else{
                    setSteps((state) => {
                        setIsLoading(false)
                        setReviewAppointmentLoader(false)
                        return Math.floor(4)
                    })
                }
            })
        }
    }
    const insuranceFormik = useFormik({
        initialValues: {
            carrier:null,
            subscriber_id:'',
            group_name:'',
            group_number:'',
            relationShip: null
        },
        enableReinitialize: true,
        validationSchema: validationSchemaForInsurance,
        onSubmit: handleInsuranceSubmit,
    })
    const updatePatient = async() =>{
        const updatedPayload = {
            "patient_id": amdPatientDetails?.id,
            "first_name": PatientCreateObject?.first_name.trim(),
            "middle_name": amdPatientDetails?.middle_name.trim(),
            "last_name" : PatientCreateObject?.last_name.trim(),
            "preferred_name" : PatientCreateObject?.preferred_name,
            "dob" : PatientCreateObject?.dob,
            "phone" : PatientCreateObject?.phone_number.trim(),
            "email" : PatientCreateObject?.email.trim(),
            "address1" : PatientCreateObject?.address_one.trim(),
            "address2" : PatientCreateObject?.address_two.trim(),
            "city" : PatientCreateObject?.city,
            "state" : PatientCreateObject?.state,
            "zip" : PatientCreateObject?.zip_code.trim(),
        }
        try{
            setIsLoading(true)
            setFromCreate(false)
            const patientUpdate = await cdphPatientUpdate(updatedPayload)
            if(patientUpdate.status == 200){
                const newData = {
                    "id": patientUpdate.data.patient?.patient_id,
                    ...patientUpdate.data.patient
                }
                dispatch(setAMDpatientCreate(newData))
                setFromCreate(true)
            }
        }catch(error){
            notification('Something went wrong!', 'error')
        }
    }

    const stepperContinueConditions = (currentStep) => {
        switch (currentStep) {
            case 0: {
                return selectedLanguage === '' 
            }
            case 0.5: {
                return findYourCareValues.bookingWith === '' 
            }
            case 2: {
                return findYourCareValues.lookingFor === ''
            }
            case 2.5: {
                return !findYourCareValues?.locatedTime || findYourCareValues.locatedTime === ''
            }
            // case 3: {
            //     return !Object.values(selectATimeValues).includes(true)
            // }
            case 3: {
                return (
                    Object.keys(selctedProviderDetails).length === 0 ||
                    Object.keys(selectedTime).length === 0
                )
            }
            // case 5: {
            //     return reasonForVisit === ''
            // }
            case 1: {
                // return false
               return  !formik.isValid || !isCheckboxEnabled
            }
            case 1.5:{
                return !insuranceFormik.values?.carrier  || !insuranceFormik.values?.subscriber_id || !insuranceFormik.values?.relationShip
                  
                
            }
            default:
                return false
        }
    }

    const providerDetails = (date = {}, ProviderDetail = {}) => {
        setSelectedTime(date)
        setSelectedProviderDetails(ProviderDetail)
        if (ProviderDetail?.specialities?.[0]) {
        const specialty = ProviderDetail.specialities[0]
        setFindYourCareValues((state) => ({
            ...state,
            lookingFor: state.lookingFor || specialty, // only set if not already set
        }))
       }
    }

    const handleCheckPatientFound = async (check = '') => {
        try {
            // Loading states
            if (!patientFoundLoading) {
                if (check === 'fromCreatePatient') {
                    dispatch(handleClickOnContinue(true));
                } else {
                    setPatientFoundModalLoading(true);
                }

                // Prepare payload
                const updatedPayload = {
                    first_name: formik.values.first_name.trim(),
                    last_name: formik.values.last_name.trim(),
                    dob: formik.values.dob,
                    zip: formik.values.zip_code.trim(),
                };

                const res = await cdphPatientFound(updatedPayload);

                if (check === 'fromCreatePatient' && res.data.message === 'Patient found') {
                    setDuplicatePatientAlert(true);
                } else if (res?.data?.message === 'Patient found') {
                    // Reset forms and flags
                    setPatientCheckExist(false);
                    setPatientexistForm({
                        first_name: '',
                        last_name: '',
                        middle_name: '',
                        zip_code: '',
                        dob: '',
                    });
                    insuranceFormik.resetForm();
                    setIsCheckboxEnabled(false);
                    setPatientHaveInsurance(false);
                    setSelfpay(false);
                    setFindYourCareValues((state) => ({ ...state, lookingFor: '' }));

                    setPatientExistIntheRecord(true);
                    setAfterPatientCheckExist(true);

                    // Set patient in redux
                    dispatch(setAMDpatientCreate(res.data.patient));

                    formik.resetForm();
                     if (res.data.patient?.insurance_Id !== '' && res.data.patient?.insurance_Id !== null) 
                        {
                            const carriers = await getCarrierList(res.data.patient.state);

                            setPatientHaveInsurance(true);
                            setPatientHaveInsuranceExist(true);

                            const patient = res.data.patient;

                            // Source provider ids from the carriers data (matched carrier's
                            // providers), consistent with the initial flow, so the availslot
                            // API receives the correct provider_ids in the follow-up flow.
                            const matchedCarrier = carriers?.find(
                                (item) => String(item?.['@id']) === String(patient?.insurance_Id)
                            );
                            setSelectedProviderIds(matchedCarrier?.providers || patient.profile_ids || []);

                            const relationshipObj = relationshipOptions.find(
                                r => String(r.key) === String(patient.relationship_id)
                            ) || null;

                            const existingInsuranceDetails = {
                                insurance_Id: patient?.insurance_Id || '',
                                //insurance_name: insurance?.['@name'] || '',
                                subscriber_id: patient?.subscriberNum || '',
                                subscriberNum: patient?.subscriberNum || '',
                                group_name: patient?.group_name || '',
                                group_number: patient?.group_number || '',
                                relationship: relationshipObj || '',
                                responsible_party: patient?.responsible_party||'',
                                patientInsuranceFront: patient?.patientInsuranceFront || null,
                                patientInsuranceBack: patient?.patientInsuranceBack || null,
                            };
                            setCurrentInsurance(existingInsuranceDetails);
                            setOriginalInsurance(existingInsuranceDetails);
                            setResponsible_party(patient?.responsible_party);
                            dispatch(setUpdateInsuranceDetails(existingInsuranceDetails));

                        }
                    // Update patient object
                    const updatedObject = {
                        first_name: res.data.patient?.first_name || '',
                        last_name: res.data.patient?.last_name || '',
                        preferred_name: res.data.patient?.preferred_name || '',
                        dob: res.data.patient?.dob || '',
                        phone_number: res.data.patient?.phone || '',
                        email: res.data.patient?.email || '',
                        address_one: res.data.patient?.address1 || '',
                        address_two: res.data.patient?.address2 || '',
                        city: res.data.patient?.city || '',
                        zip_code: res.data.patient?.zip || '',
                        state: res.data.patient?.state || '',
                    };
                    dispatch(setPatientCreateObject(updatedObject));
                    dispatch(setPatientTimeZone(res.data.patient?.timezone || "US/Pacific"));

                    // Map provider profiles with proper name handling
                    const updatedProfileDetails = res?.data?.patient?.profileList?.length > 0
                        ? res.data.patient.profileList.map((item) => {
                            const [fullName, title] = item.name?.split(",") || ["", ""];
                            const nameParts = fullName.trim().split(" ");
                            const lastName = nameParts.pop() || '';
                            const firstName = nameParts.join(" ") || '';
                            return {
                                profileId: item.id || '',
                                profileImage: item.image || '',
                                profile_specialty: item.specialty || '',
                                profile_firstName: firstName,
                                profile_lastName: lastName,
                                profileTitle: title?.trim() || '',
                                profileStates: item.states || [],
                                profileDescription: item.description || '',
                                mostRecentAppointment: item.mostRecentAppointment || null
                            };
                        })
                        : [];

                    setProviderDetailsFromPatient(updatedProfileDetails);
                    dispatch(setPrimaryProviderDetails({}));
                }
            }
        } catch (error) {
            if (error?.data?.message === 'Patient not found') {
                if (check === 'fromCreatePatient') {
                    patientHaveInsurance ? setSteps(1.5) : setSteps(2);
                    dispatch(setPatientCreateObject(formik.values));
                } else {
                    setPatientCheckExist(false);
                    setPatientExistIntheRecord(false);
                    setAfterPatientCheckExist(true);
                    setPatientexistForm({
                        first_name: '',
                        last_name: '',
                        middle_name: '',
                        zip_code: '',
                        dob: '',
                    });
                    formik.resetForm();
                    insuranceFormik.resetForm();
                    setIsCheckboxEnabled(false);
                    setPatientHaveInsurance(false);
                    setSelfpay(false);
                    setFindYourCareValues((state) => ({ ...state, lookingFor: '' }));
                }
            } else if (error?.data?.message === 'billing hold') {
                setBillingHoldAlert(true);
                setPatientCheckExist(false);
            } else {
                notification(error?.data?.message || 'Something went wrong!', 'error');
            }
        } finally {
            dispatch(handleClickOnContinue(false));
            setPatientFoundModalLoading(false);
        }
    }

    
   const getCarrierList = async (state) => {
    try {
        const res = await getCarrierListApi(state)
        if (res.status === 200) {
            const carrier = res?.data?.carriers.map((item) => {
                return {
                    ...item,
                    '@id': item['id'],                 // 👈 add this
                    '@name': item['name']
                }
            })

            const sortedCarrier = carrier.sort((a, b) => {
                if (a["@name"]?.toLowerCase() === "self pay") return -1;
                if (b["@name"]?.toLowerCase() === "self pay") return 1;
                return 0;
            })

            setCarrierList(sortedCarrier)
            return sortedCarrier
        }
    } catch (error) {
        console.log('err', error)
    }
    return []
}
    const checkTimeZone = async(value) =>{
        try{
            setLoaderOpen(true)
            const payload= {
                'zip':value
            }
            const res = await getTimeZoneFromZip(payload)
            if(res?.status == 200){
                const check = ["PST", "MST", "CST", "EST", "AKST", "HST"].includes(res?.data?.abbreviation)
                if(check){
                    formik.setFieldValue('timeZone', res?.data?.abbreviation)
                }else{
                    formik.setFieldValue('timeZone', '')
                }
            }
            setLoaderOpen(false)
        }catch(err){
            setLoaderOpen(false)
            console.log("err",err)
        }
    }

    React.useEffect(() => {
        const userState = stateList?.find(
                (stateListItem) => stateListItem?.state === userData?.state,
            )?.stateLabel,
            userTimezone =
                TIMEZONE_OPTONS?.find((timezoneList) => timezoneList.key === userData?.timezone)
                    ?.abbr || 'PST'

        handleFindYourCareValues(userState, 'locatedTime')
        handleSelectATimeValues(userTimezone, 'timezone')
    }, [userData]) 
    useEffect(()=>{
        if(steps == 1){
            formik.validateForm();
        }else if(findYourCareValues.bookingWith == 'yes' && steps === 3.5){
            dispatch(setPatientCreateObject(formik.values))
        }
    },[formik.values])
    useEffect(()=>{
        if(formik.values?.zip_code?.length > 4 && steps == 1){
            checkTimeZone(formik.values?.zip_code)
        }
    },[formik.values?.zip_code])
    useEffect(() => {
        if(steps == 1.5){
            var statename = stateList.find(x => x.state === formik.values.state)?.state;

            if (statename) 
            {
                getCarrierList(statename);
            }
        }
    }, [steps])

    useEffect(()=>{
        insuranceFormik.validateForm();
    },[insuranceFormik.values])

    useEffect(()=>{
        if(findYourCareValues.bookingWith == 'yes'){
            formik.setValues({
                ...formik.values, // keep other existing fields
                first_name: demographicDetails.first_name,
                last_name: demographicDetails.last_name,
                preferred_name: demographicDetails.preferred_name,
                dob: demographicDetails.dob,
                phone_number: demographicDetails.phone_number,
                address_one: demographicDetails.address_one,
                address_two: demographicDetails.address_two,
                city: demographicDetails.city,
                zip_code: demographicDetails.zip_code,
                state: demographicDetails.state,
                email: demographicDetails.email
            });
        }
            const updatedObject = {
                first_name: demographicDetails.first_name,
                last_name: demographicDetails.last_name,
                preferred_name: demographicDetails.preferred_name,
                dob: demographicDetails.dob,
                phone_number: demographicDetails.phone_number,
                address_one: demographicDetails.address_one,
                address_two: demographicDetails.address_two,
                city: demographicDetails.city,
                zip_code: demographicDetails.zip_code,
                state: demographicDetails.state,
                email: demographicDetails.email
            }
            dispatch(setPatientCreateObject(updatedObject))
    },[demographicDetails])
    useEffect(()=>{
        if(fromCreate && amdPatientDetails?.id ){
            if((patientHaveInsurance || selfpay) && findYourCareValues?.bookingWith === 'yes'){
                handleInsuranceSubmit()
            }else{
                handleBookAppointment(() => {
                    if(providerVisitType?.id.split(",")[0] == 'PSYINT' || providerVisitType?.id.split(",")[0] == 'PSYCHILDINT' || providerVisitType?.id.split(",")[0] == 'THERAPYINT'){
                        handleNewIntakeFormCreate()
                    }else{
                        setSteps((state) => {
                            setIsLoading(false)
                            setReviewAppointmentLoader(false)
                            return Math.floor(4)
                        })
                    }
                })
            }
            setFromCreate(false)
        }
    },[amdPatientDetails,fromCreate])

    const getGoogleTranslateCookie = () => {
        const match = document.cookie.match(/googtrans=([^;]+)/)
        return match ? match[1] : null
    }

    const handleChangeLanguage = () => {
        let langPath = window.location.hash || getGoogleTranslateCookie()
        if (!langPath) {
            setSelectedLanguage('en') // default fallback
            window.location.hash = '#googtrans(en|en)'
            return
        }
        // Extract language code properly
        let langCode = langPath ? getLangCode(langPath) :null
        switch (langCode) {
            case 'ar':
                setSelectedLanguage('ar') // Arabic
                break
            case 'zh-CN':
                setSelectedLanguage('zh-CN') // Chinese (Simplified/Traditional)
                break
            case 'ko':
                setSelectedLanguage('ko') // Korean
                break
            case 'fa':
                setSelectedLanguage('fa') // Persian
                break
            case 'vi':
                setSelectedLanguage('vi') // Vietnamese
                break
            case 'es':
                setSelectedLanguage('es') // Spanish
                break
            case 'en':
                setSelectedLanguage('en')
                break
            default: // English (default)
                // setSelectedLanguage('en')
                break
        }
    }

    //this code is implement to remove the language in cookie when the close the tab
    window.addEventListener("beforeunload", () => {
        document.cookie = "googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      });
    useEffect(()=>{
        formik.validateForm();
        handleChangeLanguage()
    },[])
    return (
        <div className={!isMobileView && classes?.mainContainer}>
            <div
                style={{ display: 'flex', flexDirection: 'column' }}
                className="outer_stepper_holder"
                ref={stepperRef}>
                <div className={ !isMobileView && classes?.backGroundImage}>
                    <AppointmentDetails />
                    <div>
                        <Booking
                            steps={steps}
                            isFirstTime={findYourCareValues.bookingWith === 'yes'}
                            isMobileView={isMobileView}
                        />
                    </div>
                    {isLoading ? (
                        <AppointmentLoadingPage steps={steps} />
                    ) : (
                        <>
                            {steps === 6 && !isMobileView && (
                                <CompletedPage isMobileView={isMobileView} />
                            )}
                            <div className="main-container">
                                <div className="doctor_care">
                                    {/* {steps != 6 && (
                                        <>
                                            <img
                                                src={doctor_img}
                                                alt="doc-img"
                                                style={{ width: isTablet ? '250px' : 'auto' }}
                                            />
                                            <Typography>
                                                We are here to provide you with quality care.
                                            </Typography>
                                            <Typography>If you need assistance call </Typography>
                                            <span className="number">'(562) 268-0955'</span>
                                        </>
                                    )} */}
                                </div>

                                <Box
                                    className="middle_portion"
                                    sx={{
                                        // paddingBottom: { sm: '60px', xl: '10px' },
                                        paddingBottom: '5px',
                                        minHeight: { sm: 'auto' },
                                    }}>
                                    <div
                                        id="google_translate_element"
                                        style={{ display: 'none' }}></div>
                                    <>
                                        {steps === 0 && <SelectLanguage value={selectedLanguage} />}
                                        {steps === 0.5 && (
                                            <BookingWith
                                                name="bookingWith"
                                                value={findYourCareValues.bookingWith}
                                                setValue={handleFindYourCareValues}
                                            />
                                        )}
                                        {steps === 1 && (
                                            <NewPatientCreateForm
                                                name="bookingWith"
                                                isMobileView={isMobileView}
                                                formik={formik}
                                                values={intakeFormFormik.values}
                                                setValues={intakeFormOnChange}
                                                sign={sign}
                                                setSign={setSign}
                                                isCheckboxEnabled={isCheckboxEnabled}
                                                setIsCheckboxEnabled={setIsCheckboxEnabled}
                                                patientHaveInsurance={patientHaveInsurance}
                                                setPatientHaveInsurance={(value) => {
                                                    setPatientHaveInsurance(value)
                                                    if (value) {
                                                        // Switching back to Insurance — reset self-pay insurance flag
                                                        setSelfpayInInsurance(false)
                                                    }
                                                }}
                                                selfpay={selfpay}
                                                setSelfpay={(value) => {
                                                    setSelfpay(value)
                                                    if (value) {
                                                        // Switching to Self Pay — clear all stale insurance data
                                                        insuranceFormik.resetForm()
                                                        setSelfpayInInsurance(false)
                                                        setSelectedProviderIds([])
                                                        setCurrentInsurance(null)
                                                        dispatch(setUpdateInsuranceDetails({}))
                                                    }
                                                }}
                                                errorMessageForRadio={errorMessageForRadio}
                                                setErrorMessageforRadio={setErrorMessageforRadio}
                                                loaderOpen={loaderOpen}
                                            />
                                        )}
                                        {/* {steps === 1.6 && (
                                        <IntakeForm medications={medications} setMedications={setMedications} />
                                    )} */}
                                        {steps === 1.5 && (
                                            <CreateInsuranceForm
                                                isMobileView={isMobileView}
                                                formik={insuranceFormik}
                                                patientInsuranceFront={patientInsuranceFront}
                                                setPatientInsuranceFront={setPatientInsuranceFront}
                                                patientInsuranceBack={patientInsuranceBack}
                                                setPatientInsuranceBack={setPatientInsuranceBack}
                                                uploadProcessFront={uploadProcessFront}
                                                setUploadProcessFront={setUploadProcessFront}
                                                uploadProcessBack={uploadProcessBack}
                                                setUploadProcessBack={setUploadProcessBack}
                                                carrierList={carrierList}
                                                selfpay={selfpayInInsurance}
                                                setSelfpay={(value) => {
                                                    setSelfpayInInsurance(value)
                                                }}
                                            />
                                        )}
                                        {steps === 2 && (
                                            <LookingFor
                                                name="lookingFor"
                                                value={findYourCareValues.lookingFor}
                                                setValue={handleFindYourCareValues}
                                                firstTime={findYourCareValues.bookingWith}
                                                isMobileView={isMobileView}
                                                providerDetailsFromPatient={
                                                    providerDetailsFromPatient
                                                }
                                                providerDetails={providerDetails}
                                                steps={steps}
                                                // handleNextStep={()=>{if (findYourCareValues.bookingWith == 'yes'){
                                                //     formik.handleSubmit()
                                                // }else{
                                                //     updatePatient()
                                                // }}}
                                                handleNextStep={() => {
                                                    updatePatient()
                                                }}
                                                patientState={confirmedPatientState || PatientCreateObject?.state}
                                                setProviderVisitType={setProviderVisitType}
                                                reasonForVisitText={reasonForVisitText}
                                                setReasonForVisitText={setReasonForVisitText}
                                                isFirstTime={
                                                    findYourCareValues?.bookingWith === 'yes'
                                                        ? true
                                                        : false
                                                }
                                                selctedProviderDetails={selctedProviderDetails}
                                                selectedTime={selectedTime}
                                                setSteps={setSteps}
                                                patientHaveInsurance={patientHaveInsuranceExist}
                                                currentInsurance={currentInsurance}
                                                carrierList={carrierList}
                                                setProviderDetailsModalOpen={setProviderDetailsModalOpen}
                                                setReasonForVisitModalOpen={setReasonForVisitModalOpen}
                                                setDemographicsModalOpen={setDemographicsModalOpen}
                                                setInsuranceModalOpen={setInsuranceModalOpen}
                                                setCareTeamFlow={setCareTeamFlow}
                                                setCareTeamSpecialty={setCareTeamSpecialty}
                                                setCareTeamProviderCount={setCareTeamProviderCount}
                                                providerIds={selectedProviderIds}
                                                onCareTeamTimeSelected={(vtId) => {
                                                    // vtId is the visit type string derived from the provider's specialty in LookingFor
                                                    const resolvedId = vtId || providerVisitType?.id?.split(',')[0]
                                                    if (resolvedId) {
                                                        setProviderVisitType(prev => {
                                                            const prevCode = prev?.id?.split(',')[0]
                                                            if (prevCode === resolvedId) return prev
                                                            return { id: resolvedId }
                                                        })
                                                    }
                                                    if (['PSYINT','PSYCHILDINT','THERAPYINT'].includes(resolvedId)) {
                                                        intakeFormNewFormik.resetForm()
                                                        setCheckboxTherapyConsent(false)
                                                        setTherapyConsentStep(1)
                                                    }
                                                    if (pendingInsuranceUpdate) {
                                                        applyInsuranceUpdate(pendingInsuranceUpdate)
                                                        setPendingInsuranceUpdate(null)
                                                    }
                                                    setPostBookingStep(3.5)
                                                    setOpenPostBookingModal(true)
                                                }}
                                                reopenProviderDetails={reopenProviderDetails}
                                                setReopenProviderDetails={setReopenProviderDetails}
                                            />
                                        )}
                                        {/* {steps === 3 && (
                                            <SelectATime
                                                lookingFor={findYourCareValues.lookingFor}
                                                value={selectATimeValues}
                                                setValue={handleSelectATimeValues}
                                                checkDisableTime={checkDisableTime}
                                                setCheckDisableTime={handleSelectDisableTime}
                                                setMaxDate={setMaxDate}
                                                // maxDate={maxDate}
                                                isMobileView={isMobileView}
                                                handleNextStep={handleNextStep}
                                                isFirstTime={
                                                    findYourCareValues?.bookingWith === 'yes'
                                                        ? true
                                                        : false
                                                }
                                            />
                                        )} */}
                                        {(steps === 3 || steps === 3.5) && (
                                            <SelectAProviderInt
                                                findYourCareValues={findYourCareValues}
                                                selectATimeValues={selectATimeValues}
                                                providerDetails={providerDetails}
                                                setProviderVisitType={setProviderVisitType}
                                                returnedErrorMessage={returnedErrorMessage}
                                                setReturnedErrorMessage={setReturnedErrorMessage}
                                                goToRequiredStep={setSteps}
                                                clinicalPracticeNumber={
                                                    userData?.practice?.patient_support_number
                                                }
                                                handleSelectATimeValues={handleSelectATimeValues}
                                                checkDisableTime={checkDisableTime}
                                                setCheckDisableTime={handleSelectDisableTime}
                                                maxDate={maxDate}
                                                steps={steps}
                                                setSteps={setSteps}
                                                handleNextStep={handleNextStep}
                                                isMobileView={isMobileView}
                                                backButton={() => {
                                                    setSteps(2)
                                                }}
                                                showCalendar={showCalendar}
                                                reasonForVisitText={reasonForVisitText}
                                                setReasonForVisitText={setReasonForVisitText}
                                                selctedProviderDetails={selctedProviderDetails}
                                                selectedTime={selectedTime}
                                                setProviderCount={setProviderCount}
                                                setProviderDetailsModalOpen={setProviderDetailsModalOpen}
                                                setReasonForVisitModalOpen={setReasonForVisitModalOpen}
                                                providerIds={selectedProviderIds}
                                                reopenProviderDetails={reopenProviderDetails}
                                                setReopenProviderDetails={setReopenProviderDetails}
                                                patientState={confirmedPatientState || PatientCreateObject?.state}
                                            />
                                            // <SelectAProvider
                                            //     findYourCareValues={findYourCareValues}
                                            //     selectATimeValues={selectATimeValues}
                                            //     providerDetails={providerDetails}
                                            //     setProviderVisitType={setProviderVisitType}
                                            //     returnedErrorMessage={returnedErrorMessage}
                                            //     setReturnedErrorMessage={setReturnedErrorMessage}
                                            //     goToRequiredStep={setSteps}
                                            //     clinicalPracticeNumber={
                                            //         userData?.practice?.patient_support_number
                                            //     }
                                            //     handleSelectATimeValues={handleSelectATimeValues}
                                            //     checkDisableTime={checkDisableTime}
                                            //     setCheckDisableTime={handleSelectDisableTime}
                                            //     maxDate={maxDate}
                                            //     steps={steps}
                                            //     setSteps={setSteps}
                                            //     handleNextStep={handleNextStep}
                                            //     isMobileView={isMobileView}
                                            //     backButton={handlePreviousStep}
                                            //     showCalendar = {showCalendar}
                                            // />
                                        )}

                                        {/* {(steps === 5 || steps === 5.5) && (
                                        <ReasonForVisit
                                            selctedProviderDetails={selctedProviderDetails}
                                            selectedTime={selectedTime}
                                            steps={steps}
                                            setSteps={setSteps}
                                            handleNextStep={handleNextStep}
                                            requireTranslator={requireTranslator}
                                            formik={formik}
                                        />
                                    )} */}
                                          {steps === 3.6 && (
                                            <InsuranceModal
                                                isOpenModal={true}
                                                setSteps={() => setSteps(3.5)}
                                                handleNextStep={() => {
                                                    if (findYourCareValues.bookingWith === 'yes') {
                                                        formik.handleSubmit()
                                                    } else {
                                                        updatePatient()
                                                    }
                                                }}
                                                carrierList={carrierList}
                                                insuranceData={{
                                                    insurance_Id: updatedInsuranceFromRedux?.insurance_Id,
                                                    insurance_name: updatedInsuranceFromRedux?.insurance_name,
                                                    subscriber_id: updatedInsuranceFromRedux?.subscriber_id,
                                                    subscriberNum: updatedInsuranceFromRedux?.subscriberNum,
                                                    group_name: updatedInsuranceFromRedux?.group_name,
                                                    group_number: updatedInsuranceFromRedux?.group_number,
                                                    relationship: updatedInsuranceFromRedux?.relationShip || updatedInsuranceFromRedux?.relationship,
                                                    patientInsuranceFront: patientInsuranceFront,
                                                    patientInsuranceBack: patientInsuranceBack,
                                                }}
                                                onUpdateInsurance={(updatedData) => {

                                                const newInsuranceId = updatedData?.insurance_Id;

                                                const isValid = validateProviderInsuranceCredential(newInsuranceId);

                                                if (!isValid) {
                                                    setPendingInsuranceUpdate(updatedData);
                                                    return;
                                                }

                                                applyInsuranceUpdate(updatedData);
                                            }}
                                            />
                                        )}
                                        {steps === 4 && (
                                            <ReviewAppointment
                                                appointmentDetails={appointmentDetails}
                                                reviewAppointmentLoader={reviewAppointmentLoader}
                                                selctedProviderDetails={selctedProviderDetails}
                                                isMobileView={isMobileView} 
                                                isFirstTime={
                                                    findYourCareValues?.bookingWith === 'yes'
                                                        ? true
                                                        : false
                                                }
                                                ispatientexist={demographicDetails.is_patient_portal_exist}
                                            />
                                        )}
                                        {steps === 6 && isMobileView && (
                                            <CompletedPage isMobileView={isMobileView} />
                                        )}
                                        <div className="common_information_holder d-lg-none">
                                            <h4 className="heading">
                                                We are here to provide you with quality care. If you
                                                need assistance call
                                            </h4>
                                            <a href="tel:+1-562-268-0955" className="content">
                                                (562) 268-0955.
                                            </a>
                                        </div>
                                        {isMobileView && (
                                            <Box
                                                className="wizard_btn_holder lll"
                                                style={{
                                                    width: 'calc(100% - 40px)',
                                                    margin: isMobileView ? 0 : '10px 0 0 20px',
                                                    backgroundColor: 'white',
                                                    zIndex: 100,
                                                }}>
                                                <BookingButtons
                                                    steps={steps}
                                                    handleNextStep={handleNextStep}
                                                    handlePreviousStep={handlePreviousStep}
                                                    stepperContinueConditions={
                                                        stepperContinueConditions
                                                    }
                                                    patientFoundLoading={false}
                                                    isLoading={isLoading}
                                                    // patientFoundLoading={patientFoundLoading}
                                                />
                                            </Box>
                                        )}
                                    </>
                                </Box>
                            </div>
                        </>
                    )}
                </div>
                <Dialog open={intakeFormWarning} onClose={() => setIntakeFormWarning(false)}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '20px',
                        }}>
                        <WarningAmberIcon style={{ fontSize: '60px', color: '#E81A1A' }} />
                        <Typography style={{ fontSize: '20px', color: '#000', margin: '25px 0px' }}>
                            If you are in crisis and need help, please call 911.
                        </Typography>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => setIntakeFormWarning(false)}
                            style={{ background: '#5571C6', width: '100%' }}>
                            Dismiss
                        </Button>
                    </div>
                </Dialog>

                {/* Behavioral Health Intake - Psychiatry (shown after date/time selection for first-time patients) */}
                <Dialog
                    open={openIntakeModal}
                    onClose={() => {
                        intakeFormNewFormik.resetForm()
                        setOpenIntakeModal(false)
                    }}
                    PaperProps={{
                        style: {
                            width: isMobileView ? 'unset' : '920px',
                            maxWidth: isMobileView ? 'unset' : '920px',
                            height: isMobileView ? 'unset' : '555px',
                        },
                    }}>
                    <IntakeNewModal
                        setOpenIntakeModal={setOpenIntakeModal}
                        intakeValues={intakeFormNewFormik}
                        intakeSetValues={intakeFormOnChangeNew}
                        setValue={() => {}}
                        isMobileView={isMobileView}
                    />
                    <div style={{ display: 'flex', justifyContent: 'end', padding: '0px 23px 23px 23px' }}>
                        <Button
                            className="providerDetailsButton"
                            disabled={
                                !intakeFormNewFormik?.values?.minor ||
                                !intakeFormNewFormik?.values?.careOrAssessment ||
                                !intakeFormNewFormik?.values?.harmingYourself ||
                                !intakeFormNewFormik?.values?.harmingOthers ||
                                !intakeFormNewFormik?.values?.alcoholAbuse ||
                                !intakeFormNewFormik?.values?.substanceAbuse
                            }
                            onClick={() => {
                                setOpenIntakeModal(false)
                                setSteps(3.5)
                            }}>
                            <span>Continue</span>
                        </Button>
                    </div>
                </Dialog>

                {/* Behavioral Health Intake - Therapy (shown after date/time selection for first-time patients) */}
                <Dialog
                    open={openIntakeTherapyModal}
                    onClose={() => {
                        setTherapyConsentStep(1)
                        setCheckboxTherapyConsent(false)
                        setOpenIntakeTherapyModal(false)
                    }}
                    PaperProps={{
                        style: {
                            width: isMobileView ? 'unset' : '920px',
                            maxWidth: isMobileView ? 'unset' : '920px',
                            height: isMobileView ? 'unset' : '555px',
                        },
                    }}>
                    <IntakeTherapyModal
                        setOpenIntakeTherapyModal={setOpenIntakeTherapyModal}
                        therapyConsentStep={therapyConsentStep}
                        setTherapyConsentStep={setTherapyConsentStep}
                        setValue={() => {}}
                    />
                    <div
                        className={classes?.therapyCheckBox}
                        style={{ padding: '0px 23px 23px 23px' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <CheckboxOption
                                name="releaseOfInfo"
                                option={{ label: '', value: true }}
                                checked={checkboxTherapyConsent}
                                onChange={() => {
                                    checkboxTherapyConsent
                                        ? setCheckboxTherapyConsent(false)
                                        : setCheckboxTherapyConsent(true)
                                }}
                                disabled={false}
                                defaultChecked={false}
                                classRoot=""
                            />
                            <Typography className={classes?.normalText}>
                                By checking this box, I consent to participate in psychotherapy
                                services and acknowledge this as my electronic signature.
                            </Typography>
                        </div>
                        {therapyConsentStep == 1 && (
                            <Button
                                className="providerDetailsButton"
                                onClick={() => { setTherapyConsentStep(2) }}>
                                <span>Next</span>
                            </Button>
                        )}
                        {therapyConsentStep == 2 && (
                            <Button
                                className="providerDetailsButton"
                                disabled={!checkboxTherapyConsent}
                                onClick={() => {
                                    setOpenIntakeTherapyModal(false)
                                    setSteps(3.5)
                                }}>
                                <span>Continue</span>
                            </Button>
                        )}
                    </div>
                </Dialog>

                {/* State location confirmation modal */}
                <StateConfirmationModal
                    open={showStateConfirmModal}
                    onClose={() => setShowStateConfirmModal(false)}
                    patientState={''}
                    onConfirm={(selectedState) => {
                        setConfirmedPatientState(selectedState)
                        setLastSuccessfulState(selectedState)
                        setShowStateConfirmModal(false)
                        intakeFormNewFormik.resetForm()
                        setCheckboxTherapyConsent(false)
                        setTherapyConsentStep(1)
                        setSteps(3)
                    }}
                />

                {/* Duplicate Patient alert */}
                <Dialog
                    open={duplicatePatientAlert}
                    onClose={() => setDuplicatePatientAlert(false)}>
                    <div className={classes.duplicatePatient}>
                        <div
                            className={classes.duplicatePatientHeaderContent}
                            onClick={() => {
                                setDuplicatePatientAlert(false)
                            }}>
                            <CloseIcon style={{ color: 'white' }} />
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '20px',
                        }}>
                        <img src={profileImage} />
                        <Typography className={classes.duplicatePatientHeader1}>
                            Looks like you may already be a patient in our system.
                        </Typography>
                        <Typography className={classes.duplicatePatientHeader2}>
                            Please give us a call to get you scheduled!
                        </Typography>
                        <Typography className={classes.duplicatePatientHeader3}>
                            (562) 268-0955
                        </Typography>
                        <Button
                            variant="contained"
                            // color="success"
                            onClick={() => {
                                formik.resetForm(),
                                    setDuplicatePatientAlert(false),
                                    setSteps(0),
                                    setSign(''),
                                    setIsCheckboxEnabled(false),
                                    setIntakeFormTouchedFields({})
                                intakeFormFormik.resetForm()
                                insuranceFormik.resetForm()
                                setFindYourCareValues((state) => {
                                    return {
                                        ...state,
                                        bookingWith: '',
                                        lookingFor: '',
                                    }
                                })
                                setSelfpay(false)
                                setPatientHaveInsurance(false)
                            }}
                            style={{
                                background: '#15a452',
                                margin: '20px 0px',
                                textTransform: 'none',
                                fontSize: '18px',
                                fontWeight: 550,
                                fontFamily: 'Inter',
                            }}>
                            <span>
                                {' '}
                                Return Home
                            </span>
                        </Button>
                    </div>
                </Dialog>

                {/*check patient exist */}
                <Dialog
                    open={patientCheckExist}
                    onClose={() => {
                        // Track patient search abandonment when modal is closed without action
                        if (patientexistForm.first_name || patientexistForm.last_name || patientexistForm.dob) {
                            trackPatientNotFoundAbandonment(patientexistForm)
                        }
                        setPatientCheckExist(false),
                            setFindYourCareValues({
                                bookingWith: '',
                                locatedTime: '',
                                lookingFor: '',
                            })
                        setPatientexistForm({
                            first_name: '',
                            last_name: '',
                            middle_name: '',
                            zip_code: '',
                            dob: '',
                        }),
                            formik.resetForm()
                        setSign(''), setIsCheckboxEnabled(false), setIntakeFormTouchedFields({})
                        intakeFormFormik.resetForm()
                        setPatientHaveInsurance(false)
                    }}>
                    <div className={classes.existPatient}>
                        <div className={classes.existPatientCheck}>
                            <Typography className={classes.existPatientHeader1}>
                                Lets find your record!
                            </Typography>
                            <div
                                onClick={() => {
                                    // Track patient search abandonment when modal is closed via X button
                                    if (patientexistForm.first_name || patientexistForm.last_name || patientexistForm.dob) {
                                        trackPatientNotFoundAbandonment(patientexistForm)
                                    }
                                    setPatientCheckExist(false),
                                        setFindYourCareValues({
                                            bookingWith: '',
                                            locatedTime: '',
                                            lookingFor: '',
                                        }),
                                        setPatientexistForm({
                                            first_name: '',
                                            last_name: '',
                                            middle_name: '',
                                            zip_code: '',
                                            dob: '',
                                        }),
                                        formik.resetForm()
                                    setSign(''),
                                        setIsCheckboxEnabled(false),
                                        setIntakeFormTouchedFields({})
                                    intakeFormFormik.resetForm()
                                    setPatientHaveInsurance(false)
                                }}>
                                <CloseIcon style={{ color: 'white' }} />
                            </div>
                        </div>
                    </div>
                    <div style={{ padding: '10px' }}>
                        <Typography
                            className={classes.duplicatePatientHeader2}
                            style={{ fontWeight: 400, fontSize: '18px' }}>
                            {/* To help us locate your record accurately, please enter your full name
                        exactly as it appears in your medical file—including any hyphens or special
                        characters. */}
                            Please enter your information exactly as it appears in your health
                            record.
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                // padding: '20px',
                            }}>
                            <div className={classes.form}>
                                <Grid container className={classes.container} spacing={2} xs={12}>
                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item xs={12} lg={6} md={6}>
                                            <TextBox
                                                label="First Name"
                                                required
                                                name="first_name"
                                                placeholder=""
                                                value={patientexistForm.first_name}
                                                onChange={(value) => {
                                                    formik.setFieldValue('first_name', value),
                                                        handleExistPatientForm(value, 'first_name')
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6} md={6}>
                                            <TextBox
                                                label="Last Name"
                                                required
                                                name="last_name"
                                                placeholder=""
                                                value={patientexistForm.last_name}
                                                onChange={(value) => {
                                                    formik.setFieldValue('last_name', value)
                                                    handleExistPatientForm(value, 'last_name')
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        alignItems="flex-start"
                                        spacing={2}
                                        style={{ marginTop: '3px' }}>
                                        <Grid item xs={12} lg={6} md={6}>
                                            <TextBox
                                                label="Zip Code"
                                                required
                                                name="zip_code"
                                                placeholder=""
                                                value={patientexistForm.zip_code}
                                                onChange={(value) => {
                                                    formik.setFieldValue(
                                                        'zip_code',
                                                        value
                                                            .replace(/[^0-9]+/g, '')
                                                            .substring(0, 5),
                                                    ),
                                                        handleExistPatientForm(
                                                            value
                                                                .replace(/[^0-9]+/g, '')
                                                                .substring(0, 5),
                                                            'zip_code',
                                                        )
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6} md={6}>
                                            {/* <DatePicker
                                            label="Date of Birth"
                                            required
                                            name="dob"
                                            maxDate={new Date()}
                                            value={patientexistForm.dob}
                                            onChange={(value) => {
                                                handleExistPatientForm(value, 'dob')
                                            }}
                                            notDefaultValue
                                            fromPatientForm="yes"
                                        /> */}
                                            <FormLabel
                                                component="p"
                                                className="d-flex justify-space-between align-center"
                                                style={{ fontSize: 14, fontWeight: 500 }}>
                                                <span
                                                    className={`${classes.checkboxLabel} required`}
                                                    style={{ color: '#303E4E' }}>
                                                    Date of Birth
                                                </span>
                                            </FormLabel>
                                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                                <KeyboardDatePicker
                                                    className="ba-input-fields each_input_holder ba-date-input"
                                                    inputVariant="outlined"
                                                    variant="inline"
                                                    format="MM/DD/YYYY"
                                                    name="dob"
                                                    maxDate={new Date()}
                                                    autoOk={true}
                                                    placeholder={''}
                                                    value={patientexistForm.dob || null}
                                                    onChange={(e) => {
                                                        if (e) {
                                                            formik.setFieldValue(
                                                                'dob',
                                                                moment(e).format('MM/DD/YYYY'),
                                                            ),
                                                                handleExistPatientForm(
                                                                    moment(e).format('MM/DD/YYYY'),
                                                                    'dob',
                                                                )
                                                        }
                                                    }}
                                                    onError={(error) => {
                                                        if (error) {
                                                            setValidDate(true)
                                                        } else {
                                                            setValidDate(false)
                                                        }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <LoadingButton
                                loading={patientFoundModalLoading}
                                variant="contained"
                                color="success"
                                disabled={
                                    !patientexistForm.first_name ||
                                    !patientexistForm.last_name ||
                                    !patientexistForm.zip_code ||
                                    !patientexistForm.dob ||
                                    validDate
                                }
                                onClick={() => {
                                    handleCheckPatientFound()
                                }}
                                sx={{
                                    '& .MuiCircularProgress-root': {
                                        color: '#fff',
                                    },
                                    minHeight: '36px',
                                    minWidth: '80px',
                                }}
                                style={{
                                    background: '#5571C6',
                                    margin: '18px 0px',
                                    textTransform: 'none',
                                    opacity:
                                        (!patientexistForm.first_name ||
                                            !patientexistForm.last_name ||
                                            !patientexistForm.zip_code ||
                                            !patientexistForm.dob ||
                                            validDate) &&
                                        '0.7',
                                }}>
                                <span
                                    style={{ fontSize: '18px', fontWeight: '550', color: '#fff', fontFamily: 'Inter' }}>
                                    {!patientFoundModalLoading ? 'Enter' : ' '}
                                </span>
                            </LoadingButton>
                        </div>
                    </div>
                </Dialog>

                {/* After patien check exist */}
                <Dialog
                    open={afterPatientCheckExist}
                    onClose={() => {
                        // Track patient not found abandonment when modal is closed without action
                        if (!patientExistIntheRecord) {
                            trackPatientNotFoundAbandonment(patientexistForm)
                        }
                        setAfterPatientCheckExist(false),
                            setFindYourCareValues({
                                bookingWith: '',
                                locatedTime: '',
                                lookingFor: '',
                            })
                    }}
                    PaperProps={{
                        style: { width: !isMobileView && '500px', maxWidth: 'unset' },
                    }}>
                    <div className={classes.existPatient}>
                        <div className={classes.existPatientCheck}>
                            <Typography className={classes.existPatientHeader1}>
                                Lets find your records!
                            </Typography>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '20px',
                        }}>
                        {patientExistIntheRecord ? (
                            <>
                                <Typography
                                    className={classes.duplicatePatientHeader2}
                                    style={{ fontWeight: 500, marginBottom: '25px' }}>
                                    We have located your patient record.
                                </Typography>
                                <div style={{ marginBottom: '10px' }}>
                                    <img src={patientRecordFound} />
                                </div>
                                <Button
                                    variant="contained"
                                    // color="success"
                                    onClick={() => {
                                        setAfterPatientCheckExist(false)
                                        setSteps(2)
                                    }}
                                    style={{
                                        background: '#15a452',
                                        margin: '20px 0px',
                                        textTransform: 'none',
                                        fontSize: '18px',
                                        fontWeight: 550 ,
                                        fontFamily: 'Inter'
                                    }}
                                   >
                                    <span>
                                        {' '}
                                        Continue
                                    </span>
                                </Button>
                            </>
                        ) : (
                            <>
                                <Typography
                                    className={classes.duplicatePatientHeader2}
                                    style={{ fontWeight: 500, marginBottom: '25px' }}>
                                    Looks like you haven't registered with us yet!
                                </Typography>
                                <div style={{ marginBottom: '10px' }}>
                                    <img src={patientRecordNotFound} />
                                </div>
                                <Typography
                                    className={classes.duplicatePatientHeader2}
                                    style={{
                                        fontWeight: 400,
                                        marginBottom: '25px',
                                        textAlign: 'center',
                                    }}>
                                    If you think there was an error please try entering your
                                    information again. Or if it's easier, you can always give us a
                                    call and we'll get your scheduled.{' '}
                                    <span
                                        className={classes.duplicatePatientHeader2}
                                        style={{ fontWeight: 500 }}>
                                        (562) 268-0955
                                    </span>
                                </Typography>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        setAfterPatientCheckExist(false)
                                        setPatientCheckExist(true)
                                    }} 
                                    style={{
                                        background: '#15a452',
                                        margin: '20px 0px',
                                        textTransform: 'none',
                                        fontSize: '18px',
                                        fontWeight: 550 ,
                                        fontFamily: 'Inter'
                                    }}
                                   >
                                    <span>
                                        {' '}
                                        Try Again
                                    </span>
                                </Button>
                            </>
                        )}
                    </div>
                </Dialog>
                {/* Billing Hold Alert Dialog - Modal (non-dismissible) */}
                <Dialog
                    open={billingHoldAlert}
                    onClose={(event, reason) => {
                        // Prevent closing on backdrop click or escape key
                        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                            return;
                        }
                        setBillingHoldAlert(false);
                    }}
                    disableEscapeKeyDown={true}
                    PaperProps={{
                        style: { 
                            width: !isMobileView ? '500px' : '90%', 
                            maxWidth: '500px',
                            borderRadius: '8px'
                        },
                    }}>
                    <div style={{
                        background: '#5571C6',
                        padding: '20px',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px'
                    }}>
                        <Typography style={{
                            fontSize: '24px',
                            fontFamily: 'Inter',
                            color: '#fff',
                            fontWeight: '500',
                        }}>
                            Account Action Needed
                        </Typography>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '30px 20px',
                            textAlign: 'center'
                        }}>
                        <Typography style={{
                            fontSize: '18px',
                            color: '#000',
                            marginBottom: '30px',
                            fontWeight: '400',
                            fontFamily: 'Inter',
                            lineHeight: '1.5'
                        }}>
                            It looks like there's a temporary issue with your account that prevents online scheduling right now.
                        </Typography>
                        
                        <Typography style={{
                            fontSize: '18px',
                            color: '#000',
                            marginBottom: '40px',
                            fontWeight: '400',
                            fontFamily: 'Inter',
                            lineHeight: '1.5'
                        }}>
                            Please give us a call at (562) 268-0955, and our team will be happy to help you get this resolved
                        </Typography>
                        
                        <Button
                            variant="contained"
                            onClick={() => {
                                setBillingHoldAlert(false)
                                // Reset all forms and states
                                formik.resetForm()
                                insuranceFormik.resetForm()
                                intakeFormFormik.resetForm()
                                setSign('')
                                setIsCheckboxEnabled(false)
                                setIntakeFormTouchedFields({})
                                setFindYourCareValues({
                                    bookingWith: '',
                                    locatedTime: '',
                                    lookingFor: '',
                                })
                                setSelfpay(false)
                                setPatientHaveInsurance(false)
                                setPatientexistForm({
                                    first_name: '',
                                    last_name: '',
                                    middle_name: '',
                                    zip_code: '',
                                    dob: '',
                                })
                                // Navigate back to home
                                setSteps(0)
                            }}
                            style={{
                                background: '#5571C6',
                                textTransform: 'none',
                                fontSize: '18px',
                                fontWeight: '500',
                                fontFamily: 'Inter',
                                padding: '12px 40px',
                                borderRadius: '6px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                            Back to Home
                        </Button>
                    </div>
                </Dialog>

                <Dialog
                    open={providerCredentialModalOpen}
                    disableEscapeKeyDown
                    onClose={() => {}}
                >
                    <Box p={4} textAlign="center">
                        <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 16 }}>
                            Provider Not Covered by Selected Insurance
                        </Typography>

                        <Typography style={{ marginBottom: 24 }}>
                            The provider you previously selected is not credentialed with your
                            updated insurance plan. To continue scheduling, please select a provider who accepts this insurance.
                        </Typography>

                        <Box display="flex" justifyContent="center" gap={2}>

                            {/* CANCEL → Revert insurance */}
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    if (originalInsurance) {
                                        dispatchInsuranceReset(originalInsurance)
                                    }
                                    setPendingInsuranceUpdate(null)
                                    setProviderCredentialModalOpen(false)
                                }}
                            >
                                Cancel
                            </Button>

                            {/* SELECT NEW PROVIDER */}
                            <Button
                                variant="contained"
                                disabled={checkingProviders}
                                onClick={() => {
                                    if (careTeamFlow) {
                                        // Async: check if specialty has providers under new insurance,
                                        // then navigate to step 3 (found) or step 2 care team (not found)
                                        handleSelectNewProvider()
                                    } else {
                                        if (pendingInsuranceUpdate) {
                                            applyInsuranceUpdate(pendingInsuranceUpdate)
                                        }
                                        setPendingInsuranceUpdate(null)
                                        setSelectedProviderDetails({})
                                        setSelectedTime({})
                                        setProviderCredentialModalOpen(false)
                                        setSteps(3)
                                    }
                                }}
                            >
                                {checkingProviders ? 'Checking...' : 'Select a New Provider'}
                            </Button>

                        </Box>
                    </Box>
                </Dialog>

                <AppointmentPostBookingModal
                    open={openPostBookingModal}
                    onClose={() => { setOpenPostBookingModal(false); setReopenProviderDetails(true) }}
                    onComplete={({ reasonText }) => {
                        setReasonForVisitText(reasonText)
                        setOpenPostBookingModal(false)
                        if (findYourCareValues.bookingWith === 'yes') {
                            formik.handleSubmit()
                        } else {
                            updatePatient()
                        }
                    }}
                    patientData={PatientCreateObject}
                    visitType={providerVisitType}
                    selfpay={findYourCareValues.bookingWith === 'yes' && (selfpay || selfpayInInsurance || !patientHaveInsurance)}
                    isMobileView={isMobileView}
                    selctedProviderDetails={selctedProviderDetails}
                    onBackToProvider={() => {
                        setOpenPostBookingModal(false)
                        setReopenProviderDetails(true)
                        if (careTeamFlow) {
                            setSteps(2)
                        } else {
                            setSteps(findYourCareValues.bookingWith === 'yes' ? 3.5 : 3)
                        }
                    }}
                    carrierList={carrierList}
                    insuranceData={{
                        insurance_Id: updatedInsuranceFromRedux?.insurance_Id,
                        insurance_name: updatedInsuranceFromRedux?.insurance_name,
                        carrier: updatedInsuranceFromRedux?.carrier,
                        subscriber_id: updatedInsuranceFromRedux?.subscriber_id,
                        subscriberNum: updatedInsuranceFromRedux?.subscriberNum,
                        group_name: updatedInsuranceFromRedux?.group_name,
                        group_number: updatedInsuranceFromRedux?.group_number,
                        relationship: updatedInsuranceFromRedux?.relationShip || updatedInsuranceFromRedux?.relationship,
                        patientInsuranceFront,
                        patientInsuranceBack,
                    }}
                    onUpdateInsurance={(updatedData) => {
                        const isValid = validateProviderInsuranceCredential(updatedData?.insurance_Id)
                        if (!isValid) { setPendingInsuranceUpdate(updatedData); return }
                        applyInsuranceUpdate(updatedData)
                    }}
                    intakeFormValues={intakeFormNewFormik}
                    intakeSetValues={intakeFormOnChangeNew}
                    checkboxTherapyConsent={checkboxTherapyConsent}
                    setCheckboxTherapyConsent={setCheckboxTherapyConsent}
                    therapyConsentStep={therapyConsentStep}
                    setTherapyConsentStep={setTherapyConsentStep}
                />
            </div>
            {!isMobileView && (
                <div className={classes?.footerContainer}>
                    <div>
                        <span className={classes?.footerText}>If you need assistance please call or text us at (562) 268-0955.</span>
                    </div>
                    <div
                        style={{
                            zIndex: 100,
                        }}>
                        <BookingButtonWeb
                            steps={steps}
                            handleNextStep={handleNextStep}
                            handlePreviousStep={handlePreviousStep}
                            stepperContinueConditions={stepperContinueConditions}
                            patientFoundLoading={false}
                            isLoading={isLoading}
                            // patientFoundLoading={patientFoundLoading}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default StepperComponents
